var items = {
  "block.minecraft.acacia_button": "Butono akacia",
  "block.minecraft.acacia_door": "Pordo akacia",
  "block.minecraft.acacia_fence": "Fenco akacia",
  "block.minecraft.acacia_fence_gate": "Pordeto akacia",
  "block.minecraft.acacia_hanging_sign": "Pendanta signo akacia",
  "block.minecraft.acacia_leaves": "Folii akacia",
  "block.minecraft.acacia_log": "Lenio akacia",
  "block.minecraft.acacia_planks": "Planki akacia",
  "block.minecraft.acacia_pressure_plate": "Presoplako akacia",
  "block.minecraft.acacia_sapling": "Arboreto akacia",
  "block.minecraft.acacia_shelf": "Acacia Shelf",
  "block.minecraft.acacia_sign": "Signo akacia",
  "block.minecraft.acacia_slab": "Plako akacia",
  "block.minecraft.acacia_stairs": "Eskalero akacia",
  "block.minecraft.acacia_trapdoor": "Trapo akacia",
  "block.minecraft.acacia_wall_hanging_sign": "Murala pendanta signo akacia",
  "block.minecraft.acacia_wall_sign": "Murala signo akacia",
  "block.minecraft.acacia_wood": "Ligno akacia",
  "block.minecraft.activator_rail": "Relo aktiviga",
  "block.minecraft.air": "Aero",
  "block.minecraft.allium": "Alliumo",
  "block.minecraft.amethyst_block": "Bloko di ametisto",
  "block.minecraft.amethyst_cluster": "Amaso di ametisto",
  "block.minecraft.ancient_debris": "Resajo anciena",
  "block.minecraft.andesite": "Andesito",
  "block.minecraft.andesite_slab": "Plako andesita",
  "block.minecraft.andesite_stairs": "Eskalero andesita",
  "block.minecraft.andesite_wall": "Muro andesita",
  "block.minecraft.anvil": "Amboso",
  "block.minecraft.attached_melon_stem": "Ligita melonstipito",
  "block.minecraft.attached_pumpkin_stem": "Stipito di kukurbito atachata",
  "block.minecraft.azalea": "Azaleo",
  "block.minecraft.azalea_leaves": "Folii azalea",
  "block.minecraft.azure_bluet": "Azura houstonio",
  "block.minecraft.bamboo": "Bambuo",
  "block.minecraft.bamboo_block": "Bloko da bambuo",
  "block.minecraft.bamboo_button": "Butono bambua",
  "block.minecraft.bamboo_door": "Pordo bambua",
  "block.minecraft.bamboo_fence": "Fenco bambua",
  "block.minecraft.bamboo_fence_gate": "Pordeto bambua",
  "block.minecraft.bamboo_hanging_sign": "Pendanta signo bambua",
  "block.minecraft.bamboo_mosaic": "Mozaiko bambua",
  "block.minecraft.bamboo_mosaic_slab": "Plako di mozaiko bambua",
  "block.minecraft.bamboo_mosaic_stairs": "Eskalero di mozaiko bambua",
  "block.minecraft.bamboo_planks": "Planki bambua",
  "block.minecraft.bamboo_pressure_plate": "Presoplako bambua",
  "block.minecraft.bamboo_sapling": "Sproso bambua",
  "block.minecraft.bamboo_shelf": "Bamboo Shelf",
  "block.minecraft.bamboo_sign": "Signo bambua",
  "block.minecraft.bamboo_slab": "Plako bambua",
  "block.minecraft.bamboo_stairs": "Eskalero bambua",
  "block.minecraft.bamboo_trapdoor": "Trapo bambua",
  "block.minecraft.bamboo_wall_hanging_sign": "Murala pendanta signo bambua",
  "block.minecraft.bamboo_wall_sign": "Murala signo bambua",
  "block.minecraft.banner.base.black": "Plene nigra kampo",
  "block.minecraft.banner.base.blue": "Plene blua kampo",
  "block.minecraft.banner.base.brown": "Plene bruna kampo",
  "block.minecraft.banner.base.cyan": "Fully Cyan Field",
  "block.minecraft.banner.base.gray": "Plene griza kampo",
  "block.minecraft.banner.base.green": "Plene verda kampo",
  "block.minecraft.banner.base.light_blue": "Fully Light Blue Field",
  "block.minecraft.banner.base.light_gray": "Plene helgriza kampo",
  "block.minecraft.banner.base.lime": "Fully Lime Field",
  "block.minecraft.banner.base.magenta": "Plene magenta kampo",
  "block.minecraft.banner.base.orange": "Fully Orange Field",
  "block.minecraft.banner.base.pink": "Fully Pink Field",
  "block.minecraft.banner.base.purple": "Plene purpura kampo",
  "block.minecraft.banner.base.red": "Plene ruga kampo",
  "block.minecraft.banner.base.white": "Plene blanka kampo",
  "block.minecraft.banner.base.yellow": "Plene flava kampo",
  "block.minecraft.banner.border.black": "Nigra bordumo",
  "block.minecraft.banner.border.blue": "Blua bordumo",
  "block.minecraft.banner.border.brown": "Bruna bordumo",
  "block.minecraft.banner.border.cyan": "Cyana bordumo",
  "block.minecraft.banner.border.gray": "Griza bordumo",
  "block.minecraft.banner.border.green": "Verda bordumo",
  "block.minecraft.banner.border.light_blue": "Cielblua bordumo",
  "block.minecraft.banner.border.light_gray": "Klargriza bordumo",
  "block.minecraft.banner.border.lime": "Klarverda bordumo",
  "block.minecraft.banner.border.magenta": "Magenta bordumo",
  "block.minecraft.banner.border.orange": "Oranjea bordumo",
  "block.minecraft.banner.border.pink": "Rozea bordumo",
  "block.minecraft.banner.border.purple": "Purpura bordumo",
  "block.minecraft.banner.border.red": "Reda bordumo",
  "block.minecraft.banner.border.white": "Blanka bordumo",
  "block.minecraft.banner.border.yellow": "Flava bordumo",
  "block.minecraft.banner.bricks.black": "Nigra brikmuro",
  "block.minecraft.banner.bricks.blue": "Blua brikmuro",
  "block.minecraft.banner.bricks.brown": "Bruna brikmuro",
  "block.minecraft.banner.bricks.cyan": "Cyana brikmuro",
  "block.minecraft.banner.bricks.gray": "Griza brikmuro",
  "block.minecraft.banner.bricks.green": "Verda brikmuro",
  "block.minecraft.banner.bricks.light_blue": "Cielblua brikmuro",
  "block.minecraft.banner.bricks.light_gray": "Klargriza brikmuro",
  "block.minecraft.banner.bricks.lime": "Klarverda brikmuro",
  "block.minecraft.banner.bricks.magenta": "Magenta brikmuro",
  "block.minecraft.banner.bricks.orange": "Oranjea brikmuro",
  "block.minecraft.banner.bricks.pink": "Rozea brikmuro",
  "block.minecraft.banner.bricks.purple": "Purpura brikmuro",
  "block.minecraft.banner.bricks.red": "Reda brikmuro",
  "block.minecraft.banner.bricks.white": "Blanka brikmuro",
  "block.minecraft.banner.bricks.yellow": "Flava brikmuro",
  "block.minecraft.banner.circle.black": "Nigra cirklo",
  "block.minecraft.banner.circle.blue": "Blua cirklo",
  "block.minecraft.banner.circle.brown": "Bruna cirklo",
  "block.minecraft.banner.circle.cyan": "Cyana cirklo",
  "block.minecraft.banner.circle.gray": "Griza cirklo",
  "block.minecraft.banner.circle.green": "Verda cirklo",
  "block.minecraft.banner.circle.light_blue": "Cielblua cirklo",
  "block.minecraft.banner.circle.light_gray": "Klargriza cirklo",
  "block.minecraft.banner.circle.lime": "Klarverda cirklo",
  "block.minecraft.banner.circle.magenta": "Magenta cirklo",
  "block.minecraft.banner.circle.orange": "Oranjea cirklo",
  "block.minecraft.banner.circle.pink": "Rozea cirklo",
  "block.minecraft.banner.circle.purple": "Purpura cirklo",
  "block.minecraft.banner.circle.red": "Reda cirklo",
  "block.minecraft.banner.circle.white": "Blanka cirklo",
  "block.minecraft.banner.circle.yellow": "Flava cirklo",
  "block.minecraft.banner.creeper.black": "Nigra vizajo di creepero",
  "block.minecraft.banner.creeper.blue": "Blua vizajo di creeper",
  "block.minecraft.banner.creeper.brown": "Bruna vizajo di creeper",
  "block.minecraft.banner.creeper.cyan": "Cyana vizajo di creeper",
  "block.minecraft.banner.creeper.gray": "Griza vizajo di creeper",
  "block.minecraft.banner.creeper.green": "Verda vizajo di creeper",
  "block.minecraft.banner.creeper.light_blue": "Cielblua vizajo di creeper",
  "block.minecraft.banner.creeper.light_gray": "Klargriza vizajo di creeper",
  "block.minecraft.banner.creeper.lime": "Klarverda vizajo di creeper",
  "block.minecraft.banner.creeper.magenta": "Magenta vizajo di creeper",
  "block.minecraft.banner.creeper.orange": "Oranjea vizajo di creeper",
  "block.minecraft.banner.creeper.pink": "Rozea vizajo di creeper",
  "block.minecraft.banner.creeper.purple": "Purpura vizajo di creeper",
  "block.minecraft.banner.creeper.red": "Reda vizajo di creeper",
  "block.minecraft.banner.creeper.white": "Blanka vizajo di creeper",
  "block.minecraft.banner.creeper.yellow": "Flava vizajo di creeper",
  "block.minecraft.banner.cross.black": "Nigra kruco diagonala",
  "block.minecraft.banner.cross.blue": "Blua kruco diagonala",
  "block.minecraft.banner.cross.brown": "Bruna kruco diagonala",
  "block.minecraft.banner.cross.cyan": "Cyana kruco diagonala",
  "block.minecraft.banner.cross.gray": "Griza kruco diagonala",
  "block.minecraft.banner.cross.green": "Verda kruco diagonala",
  "block.minecraft.banner.cross.light_blue": "Cielblua kruco diagonala",
  "block.minecraft.banner.cross.light_gray": "Klargriza kruco diagonala",
  "block.minecraft.banner.cross.lime": "Klarverda kruco diagonala",
  "block.minecraft.banner.cross.magenta": "Magenta kruco diagonala",
  "block.minecraft.banner.cross.orange": "Oranjea kruco diagonala",
  "block.minecraft.banner.cross.pink": "Rozea kruco diagonala",
  "block.minecraft.banner.cross.purple": "Purpura kruco diagonala",
  "block.minecraft.banner.cross.red": "Reda kruco diagonala",
  "block.minecraft.banner.cross.white": "Blanka kruco diagonala",
  "block.minecraft.banner.cross.yellow": "Flava kruco diagonala",
  "block.minecraft.banner.curly_border.black": "Nigra bordumo dentoza",
  "block.minecraft.banner.curly_border.blue": "Blua bordumo dentoza",
  "block.minecraft.banner.curly_border.brown": "Bruna bordumo dentoza",
  "block.minecraft.banner.curly_border.cyan": "Cyana bordumo dentoza",
  "block.minecraft.banner.curly_border.gray": "Griza bordumo dentoza",
  "block.minecraft.banner.curly_border.green": "Verda bordumo dentoza",
  "block.minecraft.banner.curly_border.light_blue": "Cielblua bordumo dentoza",
  "block.minecraft.banner.curly_border.light_gray": "Klargriza bordumo dentoza",
  "block.minecraft.banner.curly_border.lime": "Klarverda bordumo dentoza",
  "block.minecraft.banner.curly_border.magenta": "Magenta bordumo dentoza",
  "block.minecraft.banner.curly_border.orange": "Oranjea bordumo dentoza",
  "block.minecraft.banner.curly_border.pink": "Rozea bordumo dentoza",
  "block.minecraft.banner.curly_border.purple": "Purpura bordumo dentoza",
  "block.minecraft.banner.curly_border.red": "Reda bordumo dentoza",
  "block.minecraft.banner.curly_border.white": "Blanka bordumo dentoza",
  "block.minecraft.banner.curly_border.yellow": "Flava bordumo dentoza",
  "block.minecraft.banner.diagonal_left.black": "Nigra diagonalo suprasinistra",
  "block.minecraft.banner.diagonal_left.blue": "Blua diagonalo suprasinistra",
  "block.minecraft.banner.diagonal_left.brown": "Bruna diagonalo suprasinistra",
  "block.minecraft.banner.diagonal_left.cyan": "Cyana diagonalo suprasinistra",
  "block.minecraft.banner.diagonal_left.gray": "Griza diagonalo suprasinistra",
  "block.minecraft.banner.diagonal_left.green": "Verda diagonalo suprasinistra",
  "block.minecraft.banner.diagonal_left.light_blue": "Cielblua diagonalo suprasinistra",
  "block.minecraft.banner.diagonal_left.light_gray": "Klargriza diagonalo suprasinistra",
  "block.minecraft.banner.diagonal_left.lime": "Klarverda diagonalo suprasinistra",
  "block.minecraft.banner.diagonal_left.magenta": "Magenta diagonalo suprasinistra",
  "block.minecraft.banner.diagonal_left.orange": "Oranjea diagonalo suprasinistra",
  "block.minecraft.banner.diagonal_left.pink": "Rozea diagonalo suprasinistra",
  "block.minecraft.banner.diagonal_left.purple": "Purpura diagonalo suprasinistra",
  "block.minecraft.banner.diagonal_left.red": "Reda diagonalo suprasinistra",
  "block.minecraft.banner.diagonal_left.white": "Blanka diagonalo suprasinistra",
  "block.minecraft.banner.diagonal_left.yellow": "Flava diagonalo suprasinistra",
  "block.minecraft.banner.diagonal_right.black": "Nigra diagonalo supradextra",
  "block.minecraft.banner.diagonal_right.blue": "Blua diagonalo supradextra",
  "block.minecraft.banner.diagonal_right.brown": "Bruna diagonalo supradextra",
  "block.minecraft.banner.diagonal_right.cyan": "Cyana diagonalo supradextra",
  "block.minecraft.banner.diagonal_right.gray": "Griza diagonalo supradextra",
  "block.minecraft.banner.diagonal_right.green": "Verda diagonalo supradextra",
  "block.minecraft.banner.diagonal_right.light_blue": "Cielblua diagonalo supradextra",
  "block.minecraft.banner.diagonal_right.light_gray": "Klargriza diagonalo supradextra",
  "block.minecraft.banner.diagonal_right.lime": "Klarverda diagonalo supradextra",
  "block.minecraft.banner.diagonal_right.magenta": "Magenta diagonalo supradextra",
  "block.minecraft.banner.diagonal_right.orange": "Oranjea diagonalo supradextra",
  "block.minecraft.banner.diagonal_right.pink": "Rozea diagonalo supradextra",
  "block.minecraft.banner.diagonal_right.purple": "Purpura diagonalo supradextra",
  "block.minecraft.banner.diagonal_right.red": "Reda diagonalo supradextra",
  "block.minecraft.banner.diagonal_right.white": "Blanka diagonalo supradextra",
  "block.minecraft.banner.diagonal_right.yellow": "Flava diagonalo supradextra",
  "block.minecraft.banner.diagonal_up_left.black": "Nigra diagonalo infradextra",
  "block.minecraft.banner.diagonal_up_left.blue": "Blua diagonalo infradextra",
  "block.minecraft.banner.diagonal_up_left.brown": "Bruna diagonalo infradextra",
  "block.minecraft.banner.diagonal_up_left.cyan": "Cyana diagonalo infradextra",
  "block.minecraft.banner.diagonal_up_left.gray": "Griza diagonalo infradextra",
  "block.minecraft.banner.diagonal_up_left.green": "Verda diagonalo infradextra",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Cielblua diagonalo infradextra",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Klargriza diagonalo infradextra",
  "block.minecraft.banner.diagonal_up_left.lime": "Klarverda diagonalo infradextra",
  "block.minecraft.banner.diagonal_up_left.magenta": "Magenta diagonalo infradextra",
  "block.minecraft.banner.diagonal_up_left.orange": "Oranjea diagonalo infradextra",
  "block.minecraft.banner.diagonal_up_left.pink": "Rozea diagonalo infradextra",
  "block.minecraft.banner.diagonal_up_left.purple": "Purpura diagonalo infradextra",
  "block.minecraft.banner.diagonal_up_left.red": "Reda diagonalo infradextra",
  "block.minecraft.banner.diagonal_up_left.white": "Blanka diagonalo infradextra",
  "block.minecraft.banner.diagonal_up_left.yellow": "Flava diagonalo infradextra",
  "block.minecraft.banner.diagonal_up_right.black": "Nigra diagonalo infrasinistra",
  "block.minecraft.banner.diagonal_up_right.blue": "Blua diagonalo infrasinistra",
  "block.minecraft.banner.diagonal_up_right.brown": "Bruna diagonalo infrasinistra",
  "block.minecraft.banner.diagonal_up_right.cyan": "Cyana diagonalo infrasinistra",
  "block.minecraft.banner.diagonal_up_right.gray": "Griza diagonalo infrasinistra",
  "block.minecraft.banner.diagonal_up_right.green": "Verda diagonalo infrasinistra",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Cielblua diagonalo infrasinistra",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Klargriza diagonalo infrasinistra",
  "block.minecraft.banner.diagonal_up_right.lime": "Klarverda diagonalo infrasinistra",
  "block.minecraft.banner.diagonal_up_right.magenta": "Magenta diagonalo infrasinistra",
  "block.minecraft.banner.diagonal_up_right.orange": "Oranjea diagonalo infrasinistra",
  "block.minecraft.banner.diagonal_up_right.pink": "Rozea diagonalo infrasinistra",
  "block.minecraft.banner.diagonal_up_right.purple": "Purpura diagonalo infrasinistra",
  "block.minecraft.banner.diagonal_up_right.red": "Reda diagonalo infrasinistra",
  "block.minecraft.banner.diagonal_up_right.white": "Blanka diagonalo infrasinistra",
  "block.minecraft.banner.diagonal_up_right.yellow": "Flava diagonalo infrasinistra",
  "block.minecraft.banner.flow.black": "Nigra Fluo",
  "block.minecraft.banner.flow.blue": "Blua Fluo",
  "block.minecraft.banner.flow.brown": "Bruna Fluo",
  "block.minecraft.banner.flow.cyan": "Cyana Fluo",
  "block.minecraft.banner.flow.gray": "Griza Fluo",
  "block.minecraft.banner.flow.green": "Verda Fluo",
  "block.minecraft.banner.flow.light_blue": "Cielblua Fluo",
  "block.minecraft.banner.flow.light_gray": "Hela Griza Fluo",
  "block.minecraft.banner.flow.lime": "Lime Flow",
  "block.minecraft.banner.flow.magenta": "Magenta Fluo",
  "block.minecraft.banner.flow.orange": "Oranjea Fluo",
  "block.minecraft.banner.flow.pink": "Rozea Fluo",
  "block.minecraft.banner.flow.purple": "Violeta Fluo",
  "block.minecraft.banner.flow.red": "Ruga Fluo",
  "block.minecraft.banner.flow.white": "Blanka Fluo",
  "block.minecraft.banner.flow.yellow": "Flava Fluo",
  "block.minecraft.banner.flower.black": "Nigra floro",
  "block.minecraft.banner.flower.blue": "Blua floro",
  "block.minecraft.banner.flower.brown": "Bruna floro",
  "block.minecraft.banner.flower.cyan": "Cyana floro",
  "block.minecraft.banner.flower.gray": "Griza floro",
  "block.minecraft.banner.flower.green": "Verda floro",
  "block.minecraft.banner.flower.light_blue": "Cielblua floro",
  "block.minecraft.banner.flower.light_gray": "Klargriza floro",
  "block.minecraft.banner.flower.lime": "Klarverda floro",
  "block.minecraft.banner.flower.magenta": "Magenta floro",
  "block.minecraft.banner.flower.orange": "Oranjea floro",
  "block.minecraft.banner.flower.pink": "Rozea floro",
  "block.minecraft.banner.flower.purple": "Purpura floro",
  "block.minecraft.banner.flower.red": "Reda floro",
  "block.minecraft.banner.flower.white": "Blanka floro",
  "block.minecraft.banner.flower.yellow": "Flava floro",
  "block.minecraft.banner.globe.black": "Nigra globo",
  "block.minecraft.banner.globe.blue": "Blua globo",
  "block.minecraft.banner.globe.brown": "Bruna globo",
  "block.minecraft.banner.globe.cyan": "Cyana globo",
  "block.minecraft.banner.globe.gray": "Griza globo",
  "block.minecraft.banner.globe.green": "Verda globo",
  "block.minecraft.banner.globe.light_blue": "Cielblua globo",
  "block.minecraft.banner.globe.light_gray": "Klargriza globo",
  "block.minecraft.banner.globe.lime": "Klarverda globo",
  "block.minecraft.banner.globe.magenta": "Magenta globo",
  "block.minecraft.banner.globe.orange": "Oranjea globo",
  "block.minecraft.banner.globe.pink": "Rozea globo",
  "block.minecraft.banner.globe.purple": "Purpura globo",
  "block.minecraft.banner.globe.red": "Reda globo",
  "block.minecraft.banner.globe.white": "Blanka globo",
  "block.minecraft.banner.globe.yellow": "Flava globo",
  "block.minecraft.banner.gradient.black": "Nigra gradiento supra",
  "block.minecraft.banner.gradient.blue": "Blua gradiento supra",
  "block.minecraft.banner.gradient.brown": "Bruna gradiento supra",
  "block.minecraft.banner.gradient.cyan": "Cyana gradiento supra",
  "block.minecraft.banner.gradient.gray": "Griza gradiento supra",
  "block.minecraft.banner.gradient.green": "Verda gradiento supra",
  "block.minecraft.banner.gradient.light_blue": "Cielblua gradiento supra",
  "block.minecraft.banner.gradient.light_gray": "Klargriza gradiento supra",
  "block.minecraft.banner.gradient.lime": "Klarverda gradiento supra",
  "block.minecraft.banner.gradient.magenta": "Magenta gradiento supra",
  "block.minecraft.banner.gradient.orange": "Oranjea gradiento supra",
  "block.minecraft.banner.gradient.pink": "Rozea gradiento supra",
  "block.minecraft.banner.gradient.purple": "Purpura gradiento supra",
  "block.minecraft.banner.gradient.red": "Reda gradiento supra",
  "block.minecraft.banner.gradient.white": "Blanka gradiento supra",
  "block.minecraft.banner.gradient.yellow": "Flava gradiento supra",
  "block.minecraft.banner.gradient_up.black": "Nigra gradiento infra",
  "block.minecraft.banner.gradient_up.blue": "Blua gradiento infra",
  "block.minecraft.banner.gradient_up.brown": "Bruna gradiento infra",
  "block.minecraft.banner.gradient_up.cyan": "Cyana gradiento infra",
  "block.minecraft.banner.gradient_up.gray": "Griza gradiento infra",
  "block.minecraft.banner.gradient_up.green": "Verda gradiento infra",
  "block.minecraft.banner.gradient_up.light_blue": "Cielblua gradiento infra",
  "block.minecraft.banner.gradient_up.light_gray": "Klargriza gradiento infra",
  "block.minecraft.banner.gradient_up.lime": "Klarverda gradiento infra",
  "block.minecraft.banner.gradient_up.magenta": "Magenta gradiento infra",
  "block.minecraft.banner.gradient_up.orange": "Oranjea gradiento infra",
  "block.minecraft.banner.gradient_up.pink": "Rozea gradiento infra",
  "block.minecraft.banner.gradient_up.purple": "Purpura gradiento infra",
  "block.minecraft.banner.gradient_up.red": "Reda gradiento infra",
  "block.minecraft.banner.gradient_up.white": "Blanka gradiento infra",
  "block.minecraft.banner.gradient_up.yellow": "Flava gradiento infra",
  "block.minecraft.banner.guster.black": "Nigra Virvolto",
  "block.minecraft.banner.guster.blue": "Blua Virvolto",
  "block.minecraft.banner.guster.brown": "Bruna Virvolto",
  "block.minecraft.banner.guster.cyan": "Cyana Virvolto",
  "block.minecraft.banner.guster.gray": "Griza Virvolto",
  "block.minecraft.banner.guster.green": "Verda Virvolto",
  "block.minecraft.banner.guster.light_blue": "Cielblua Virvolto",
  "block.minecraft.banner.guster.light_gray": "Klargriza Virvolto",
  "block.minecraft.banner.guster.lime": "Klarverda Virvolto",
  "block.minecraft.banner.guster.magenta": "Magenta Virvolto",
  "block.minecraft.banner.guster.orange": "Oranjea Virvolto",
  "block.minecraft.banner.guster.pink": "Rozea Virvolto",
  "block.minecraft.banner.guster.purple": "Purpura Virvolto",
  "block.minecraft.banner.guster.red": "Reda Virvolto",
  "block.minecraft.banner.guster.white": "Blanka Virvolto",
  "block.minecraft.banner.guster.yellow": "Flava Virvolto",
  "block.minecraft.banner.half_horizontal.black": "Nigra duimo supra",
  "block.minecraft.banner.half_horizontal.blue": "Blua duimo supra",
  "block.minecraft.banner.half_horizontal.brown": "Bruna duimo supra",
  "block.minecraft.banner.half_horizontal.cyan": "Cyana duimo supra",
  "block.minecraft.banner.half_horizontal.gray": "Griza duimo supra",
  "block.minecraft.banner.half_horizontal.green": "Verda duimo supra",
  "block.minecraft.banner.half_horizontal.light_blue": "Cielblua duimo supra",
  "block.minecraft.banner.half_horizontal.light_gray": "Klargriza duimo supra",
  "block.minecraft.banner.half_horizontal.lime": "Klarverda duimo supra",
  "block.minecraft.banner.half_horizontal.magenta": "Magenta duimo supra",
  "block.minecraft.banner.half_horizontal.orange": "Oranjea duimo supra",
  "block.minecraft.banner.half_horizontal.pink": "Rozea duimo supra",
  "block.minecraft.banner.half_horizontal.purple": "Purpura duimo supra",
  "block.minecraft.banner.half_horizontal.red": "Reda duimo supra",
  "block.minecraft.banner.half_horizontal.white": "Blanka duimo supra",
  "block.minecraft.banner.half_horizontal.yellow": "Flava duimo supra",
  "block.minecraft.banner.half_horizontal_bottom.black": "Nigra duimo infra",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Blua duimo infra",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Bruna duimo infra",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Cyana duimo infra",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Griza duimo infra",
  "block.minecraft.banner.half_horizontal_bottom.green": "Verda duimo infra",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Cielblua duimo infra",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Klargriza duimo infra",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Klarverda duimo infra",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Magenta duimo infra",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Oranjea duimo infra",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Rozea duimo infra",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Purpura duimo infra",
  "block.minecraft.banner.half_horizontal_bottom.red": "Reda duimo infra",
  "block.minecraft.banner.half_horizontal_bottom.white": "Blanka duimo infra",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Flava duimo infra",
  "block.minecraft.banner.half_vertical.black": "Nigra duimo sinistra",
  "block.minecraft.banner.half_vertical.blue": "Blua diagonalo infrasinistra",
  "block.minecraft.banner.half_vertical.brown": "Bruna diagonalo infrasinistra",
  "block.minecraft.banner.half_vertical.cyan": "Cyana diagonalo infrasinistra",
  "block.minecraft.banner.half_vertical.gray": "Griza diagonalo infrasinistra",
  "block.minecraft.banner.half_vertical.green": "Verda diagonalo infrasinistra",
  "block.minecraft.banner.half_vertical.light_blue": "Cielblua diagonalo infrasinistra",
  "block.minecraft.banner.half_vertical.light_gray": "Klargriza diagonalo infrasinistra",
  "block.minecraft.banner.half_vertical.lime": "Klarverda diagonalo infrasinistra",
  "block.minecraft.banner.half_vertical.magenta": "Magenta diagonalo infrasinistra",
  "block.minecraft.banner.half_vertical.orange": "Oranjea diagonalo infrasinistra",
  "block.minecraft.banner.half_vertical.pink": "Rozea diagonalo infrasinistra",
  "block.minecraft.banner.half_vertical.purple": "Purpura diagonalo infrasinistra",
  "block.minecraft.banner.half_vertical.red": "Reda duimo sinistra",
  "block.minecraft.banner.half_vertical.white": "Blanka diagonalo infrasinistra",
  "block.minecraft.banner.half_vertical.yellow": "Flava diagonalo infrasinistra",
  "block.minecraft.banner.half_vertical_right.black": "Nigra duimo dextra",
  "block.minecraft.banner.half_vertical_right.blue": "Blua duimo dextra",
  "block.minecraft.banner.half_vertical_right.brown": "Bruna duimo dextra",
  "block.minecraft.banner.half_vertical_right.cyan": "Cyana duimo dextra",
  "block.minecraft.banner.half_vertical_right.gray": "Griza duimo dextra",
  "block.minecraft.banner.half_vertical_right.green": "Verda duimo dextra",
  "block.minecraft.banner.half_vertical_right.light_blue": "Cielblua duimo dextra",
  "block.minecraft.banner.half_vertical_right.light_gray": "Klargriza duimo dextra",
  "block.minecraft.banner.half_vertical_right.lime": "Klarverda duimo dextra",
  "block.minecraft.banner.half_vertical_right.magenta": "Magenta duimo dextra",
  "block.minecraft.banner.half_vertical_right.orange": "Oranjea duimo dextra",
  "block.minecraft.banner.half_vertical_right.pink": "Rozea duimo dextra",
  "block.minecraft.banner.half_vertical_right.purple": "Purpura duimo dextra",
  "block.minecraft.banner.half_vertical_right.red": "Reda duimo dextra",
  "block.minecraft.banner.half_vertical_right.white": "Blanka duimo dextra",
  "block.minecraft.banner.half_vertical_right.yellow": "Flava duimo dextra",
  "block.minecraft.banner.mojang.black": "Nigra insigno",
  "block.minecraft.banner.mojang.blue": "Blua insigno",
  "block.minecraft.banner.mojang.brown": "Bruna insigno",
  "block.minecraft.banner.mojang.cyan": "Cyana insigno",
  "block.minecraft.banner.mojang.gray": "Griza insigno",
  "block.minecraft.banner.mojang.green": "Verda insigno",
  "block.minecraft.banner.mojang.light_blue": "Cielblua insigno",
  "block.minecraft.banner.mojang.light_gray": "Klargriza insigno",
  "block.minecraft.banner.mojang.lime": "Klarverda insigno",
  "block.minecraft.banner.mojang.magenta": "Magenta insigno",
  "block.minecraft.banner.mojang.orange": "Oranjea insigno",
  "block.minecraft.banner.mojang.pink": "Rozea insigno",
  "block.minecraft.banner.mojang.purple": "Purpura insigno",
  "block.minecraft.banner.mojang.red": "Reda insigno",
  "block.minecraft.banner.mojang.white": "Blanka insigno",
  "block.minecraft.banner.mojang.yellow": "Flava insigno",
  "block.minecraft.banner.piglin.black": "Nigra musaĉa vizaĝo",
  "block.minecraft.banner.piglin.blue": "Blua musaĉa vizaĝo",
  "block.minecraft.banner.piglin.brown": "Bruna musaĉa vizaĝo",
  "block.minecraft.banner.piglin.cyan": "Cyan Snout",
  "block.minecraft.banner.piglin.gray": "Griza musaĉa vizaĝo",
  "block.minecraft.banner.piglin.green": "Verda musaĉa vizaĝo",
  "block.minecraft.banner.piglin.light_blue": "Helblua musaĉa vizaĝo",
  "block.minecraft.banner.piglin.light_gray": "Helgriza musaĉa vizaĝo",
  "block.minecraft.banner.piglin.lime": "Lime Snout",
  "block.minecraft.banner.piglin.magenta": "Magenta musaĉa vizaĝo",
  "block.minecraft.banner.piglin.orange": "Orange Snout",
  "block.minecraft.banner.piglin.pink": "Pink Snout",
  "block.minecraft.banner.piglin.purple": "Purpura musaĉa vizaĝo",
  "block.minecraft.banner.piglin.red": "Ruĝa musaĉa vizaĝo",
  "block.minecraft.banner.piglin.white": "Blanka musaĉa vizaĝo",
  "block.minecraft.banner.piglin.yellow": "Flava musaĉa vizaĝo",
  "block.minecraft.banner.rhombus.black": "Nigra rombo",
  "block.minecraft.banner.rhombus.blue": "Blua rombo",
  "block.minecraft.banner.rhombus.brown": "Bruna rombo",
  "block.minecraft.banner.rhombus.cyan": "Cyana rombo",
  "block.minecraft.banner.rhombus.gray": "Griza rombo",
  "block.minecraft.banner.rhombus.green": "Verda rombo",
  "block.minecraft.banner.rhombus.light_blue": "Cielblua rombo",
  "block.minecraft.banner.rhombus.light_gray": "Klargriza rombo",
  "block.minecraft.banner.rhombus.lime": "Klarverda rombo",
  "block.minecraft.banner.rhombus.magenta": "Magenta rombo",
  "block.minecraft.banner.rhombus.orange": "Oranjea rombo",
  "block.minecraft.banner.rhombus.pink": "Rozea rombo",
  "block.minecraft.banner.rhombus.purple": "Purpura rombo",
  "block.minecraft.banner.rhombus.red": "Reda rombo",
  "block.minecraft.banner.rhombus.white": "Blanka rombo",
  "block.minecraft.banner.rhombus.yellow": "Flava rombo",
  "block.minecraft.banner.skull.black": "Nigra kranio",
  "block.minecraft.banner.skull.blue": "Blua kranio",
  "block.minecraft.banner.skull.brown": "Bruna kranio",
  "block.minecraft.banner.skull.cyan": "Cyana kranio",
  "block.minecraft.banner.skull.gray": "Griza kranio",
  "block.minecraft.banner.skull.green": "Verda kranio",
  "block.minecraft.banner.skull.light_blue": "Cielblua kranio",
  "block.minecraft.banner.skull.light_gray": "Klargriza kranio",
  "block.minecraft.banner.skull.lime": "Klarverda kranio",
  "block.minecraft.banner.skull.magenta": "Magenta kranio",
  "block.minecraft.banner.skull.orange": "Oranjea kranio",
  "block.minecraft.banner.skull.pink": "Rozea kranio",
  "block.minecraft.banner.skull.purple": "Purpura kranio",
  "block.minecraft.banner.skull.red": "Reda kranio",
  "block.minecraft.banner.skull.white": "Blanka kranio",
  "block.minecraft.banner.skull.yellow": "Flava kranio",
  "block.minecraft.banner.small_stripes.black": "Nigra strieti",
  "block.minecraft.banner.small_stripes.blue": "Blua strieti",
  "block.minecraft.banner.small_stripes.brown": "Bruna strieti",
  "block.minecraft.banner.small_stripes.cyan": "Cyana strieti",
  "block.minecraft.banner.small_stripes.gray": "Griza strieti",
  "block.minecraft.banner.small_stripes.green": "Verda strieti",
  "block.minecraft.banner.small_stripes.light_blue": "Cielblua strieti",
  "block.minecraft.banner.small_stripes.light_gray": "Klargriza strieti",
  "block.minecraft.banner.small_stripes.lime": "Klarverda strieti",
  "block.minecraft.banner.small_stripes.magenta": "Magenta strieti",
  "block.minecraft.banner.small_stripes.orange": "Oranjea strieti",
  "block.minecraft.banner.small_stripes.pink": "Rozea strieti",
  "block.minecraft.banner.small_stripes.purple": "Purpura strieti",
  "block.minecraft.banner.small_stripes.red": "Reda strieti",
  "block.minecraft.banner.small_stripes.white": "Blanka strieti",
  "block.minecraft.banner.small_stripes.yellow": "Flava strieti",
  "block.minecraft.banner.square_bottom_left.black": "Nigra quadranto infradextra",
  "block.minecraft.banner.square_bottom_left.blue": "Blua quadranto infradextra",
  "block.minecraft.banner.square_bottom_left.brown": "Bruna quadranto infradextra",
  "block.minecraft.banner.square_bottom_left.cyan": "Ciana quadranto infradextra",
  "block.minecraft.banner.square_bottom_left.gray": "Griza quadranto infradextra",
  "block.minecraft.banner.square_bottom_left.green": "Verda quadranto infradextra",
  "block.minecraft.banner.square_bottom_left.light_blue": "Cielblua quadranto infradextra",
  "block.minecraft.banner.square_bottom_left.light_gray": "Klargriza quadranto infradextra",
  "block.minecraft.banner.square_bottom_left.lime": "Klarverda quadranto infradextra",
  "block.minecraft.banner.square_bottom_left.magenta": "Magenta quadranto infradextra",
  "block.minecraft.banner.square_bottom_left.orange": "Oranjea quadranto infradextra",
  "block.minecraft.banner.square_bottom_left.pink": "Rozea quadranto infradextra",
  "block.minecraft.banner.square_bottom_left.purple": "Purpura quadranto infradextra",
  "block.minecraft.banner.square_bottom_left.red": "Reda quadranto infradextra",
  "block.minecraft.banner.square_bottom_left.white": "Blanka quadranto infradextra",
  "block.minecraft.banner.square_bottom_left.yellow": "Flava quadranto infradextra",
  "block.minecraft.banner.square_bottom_right.black": "Nigra quadranto infrasinistra",
  "block.minecraft.banner.square_bottom_right.blue": "Blua quadranto infrasinistra",
  "block.minecraft.banner.square_bottom_right.brown": "Bruna quadranto infrasinistra",
  "block.minecraft.banner.square_bottom_right.cyan": "Ciana quadranto infrasinistra",
  "block.minecraft.banner.square_bottom_right.gray": "Griza quadranto infrasinistra",
  "block.minecraft.banner.square_bottom_right.green": "Verda quadranto infrasinistra",
  "block.minecraft.banner.square_bottom_right.light_blue": "Cielblua quadranto infrasinistra",
  "block.minecraft.banner.square_bottom_right.light_gray": "Klargriza quadranto infrasinistra",
  "block.minecraft.banner.square_bottom_right.lime": "Klarverda quadranto infrasinistra",
  "block.minecraft.banner.square_bottom_right.magenta": "Magenta quadranto infrasinistra",
  "block.minecraft.banner.square_bottom_right.orange": "Oreanjea quadranto infrasinistra",
  "block.minecraft.banner.square_bottom_right.pink": "Rozea quadranto infrasinistra",
  "block.minecraft.banner.square_bottom_right.purple": "Purpura quadranto infrasinistra",
  "block.minecraft.banner.square_bottom_right.red": "Reda quadranto infrasinistra",
  "block.minecraft.banner.square_bottom_right.white": "Blanka quadranto infrasinistra",
  "block.minecraft.banner.square_bottom_right.yellow": "Flava quadranto infrasinistra",
  "block.minecraft.banner.square_top_left.black": "Nigra quadranto supradextra",
  "block.minecraft.banner.square_top_left.blue": "Blua quadranto supradextra",
  "block.minecraft.banner.square_top_left.brown": "Bruna quadranto supradextra",
  "block.minecraft.banner.square_top_left.cyan": "Ciana quadranto supradextra",
  "block.minecraft.banner.square_top_left.gray": "Griza quadranto supradextra",
  "block.minecraft.banner.square_top_left.green": "Verda quadranto supradextra",
  "block.minecraft.banner.square_top_left.light_blue": "Cielblua quadranto supradextra",
  "block.minecraft.banner.square_top_left.light_gray": "Klargriza quadranto supradextra",
  "block.minecraft.banner.square_top_left.lime": "Klarverda quadranto supradextra",
  "block.minecraft.banner.square_top_left.magenta": "Magenta quadranto supradextra",
  "block.minecraft.banner.square_top_left.orange": "Oranjea quadranto supradextra",
  "block.minecraft.banner.square_top_left.pink": "Rozea quadranto supradextra",
  "block.minecraft.banner.square_top_left.purple": "Purpura quadranto supradextra",
  "block.minecraft.banner.square_top_left.red": "Reda quadranto supradextra",
  "block.minecraft.banner.square_top_left.white": "Blanka quadranto supradextra",
  "block.minecraft.banner.square_top_left.yellow": "Flava quadranto supradextra",
  "block.minecraft.banner.square_top_right.black": "Nigra quadranto suprasinistra",
  "block.minecraft.banner.square_top_right.blue": "Blua quadranto suprasinistra",
  "block.minecraft.banner.square_top_right.brown": "Bruna quadranto suprasinistra",
  "block.minecraft.banner.square_top_right.cyan": "Ciana quadranto suprasinistra",
  "block.minecraft.banner.square_top_right.gray": "Griza quadranto suprasinistra",
  "block.minecraft.banner.square_top_right.green": "Verda quadranto suprasinistra",
  "block.minecraft.banner.square_top_right.light_blue": "Cielblua quadranto suprasinistra",
  "block.minecraft.banner.square_top_right.light_gray": "Klargriza quadranto suprasinistra",
  "block.minecraft.banner.square_top_right.lime": "Klarverda quadranto suprasinistra",
  "block.minecraft.banner.square_top_right.magenta": "Magenta quadranto suprasinistra",
  "block.minecraft.banner.square_top_right.orange": "Oranjea quadranto suprasinistra",
  "block.minecraft.banner.square_top_right.pink": "Rozea quadranto suprasinistra",
  "block.minecraft.banner.square_top_right.purple": "Purpura quadranto suprasinistra",
  "block.minecraft.banner.square_top_right.red": "Reda quadranto suprasinistra",
  "block.minecraft.banner.square_top_right.white": "Blanka quadranto suprasinistra",
  "block.minecraft.banner.square_top_right.yellow": "Flava quadranto suprasinistra",
  "block.minecraft.banner.straight_cross.black": "Nigra kruco",
  "block.minecraft.banner.straight_cross.blue": "Blua kruco",
  "block.minecraft.banner.straight_cross.brown": "Bruna kruco",
  "block.minecraft.banner.straight_cross.cyan": "Cyana kruco",
  "block.minecraft.banner.straight_cross.gray": "Griza kruco",
  "block.minecraft.banner.straight_cross.green": "Verda kruco",
  "block.minecraft.banner.straight_cross.light_blue": "Cielblua kruco",
  "block.minecraft.banner.straight_cross.light_gray": "Klargriza kruco",
  "block.minecraft.banner.straight_cross.lime": "Klarverda kruco",
  "block.minecraft.banner.straight_cross.magenta": "Magenta kruco",
  "block.minecraft.banner.straight_cross.orange": "Oranjea kruco",
  "block.minecraft.banner.straight_cross.pink": "Rozea kruco",
  "block.minecraft.banner.straight_cross.purple": "Purpura kruco",
  "block.minecraft.banner.straight_cross.red": "Reda kruco",
  "block.minecraft.banner.straight_cross.white": "Blanka kruco",
  "block.minecraft.banner.straight_cross.yellow": "Flava kruco",
  "block.minecraft.banner.stripe_bottom.black": "Nigra bazo",
  "block.minecraft.banner.stripe_bottom.blue": "Blua bazo",
  "block.minecraft.banner.stripe_bottom.brown": "Bruna bazo",
  "block.minecraft.banner.stripe_bottom.cyan": "Ciana bazo",
  "block.minecraft.banner.stripe_bottom.gray": "Griza bazo",
  "block.minecraft.banner.stripe_bottom.green": "Verda bazo",
  "block.minecraft.banner.stripe_bottom.light_blue": "Cielblua bazo",
  "block.minecraft.banner.stripe_bottom.light_gray": "Klargriza bazo",
  "block.minecraft.banner.stripe_bottom.lime": "Klarverda bazo",
  "block.minecraft.banner.stripe_bottom.magenta": "Magenta bazo",
  "block.minecraft.banner.stripe_bottom.orange": "Oranjea bazo",
  "block.minecraft.banner.stripe_bottom.pink": "Rozea bazo",
  "block.minecraft.banner.stripe_bottom.purple": "Purpura bazo",
  "block.minecraft.banner.stripe_bottom.red": "Reda bazo",
  "block.minecraft.banner.stripe_bottom.white": "Blanka bazo",
  "block.minecraft.banner.stripe_bottom.yellow": "Flava bazo",
  "block.minecraft.banner.stripe_center.black": "Nigra strio centrala",
  "block.minecraft.banner.stripe_center.blue": "Blua strio centrala",
  "block.minecraft.banner.stripe_center.brown": "Bruna strio centrala",
  "block.minecraft.banner.stripe_center.cyan": "Cyana strio centrala",
  "block.minecraft.banner.stripe_center.gray": "Griza strio centrala",
  "block.minecraft.banner.stripe_center.green": "Verda strio centrala",
  "block.minecraft.banner.stripe_center.light_blue": "Cielblua strio centrala",
  "block.minecraft.banner.stripe_center.light_gray": "Klargriza strio centrala",
  "block.minecraft.banner.stripe_center.lime": "Klarverda strio centrala",
  "block.minecraft.banner.stripe_center.magenta": "Magenta strio centrala",
  "block.minecraft.banner.stripe_center.orange": "Oranjea strio centrala",
  "block.minecraft.banner.stripe_center.pink": "Rozea strio centrala",
  "block.minecraft.banner.stripe_center.purple": "Purpura strio centrala",
  "block.minecraft.banner.stripe_center.red": "Reda strio centrala",
  "block.minecraft.banner.stripe_center.white": "Blanka strio centrala",
  "block.minecraft.banner.stripe_center.yellow": "Flava strio centrala",
  "block.minecraft.banner.stripe_downleft.black": "Nigra diagonalo sinistra",
  "block.minecraft.banner.stripe_downleft.blue": "Blua diagonalo sinistra",
  "block.minecraft.banner.stripe_downleft.brown": "Bruna diagonalo sinistra",
  "block.minecraft.banner.stripe_downleft.cyan": "Cyana diagonalo sinistra",
  "block.minecraft.banner.stripe_downleft.gray": "Griza diagonalo sinistra",
  "block.minecraft.banner.stripe_downleft.green": "Verda diagonalo sinistra",
  "block.minecraft.banner.stripe_downleft.light_blue": "Cielblua diagonalo sinistra",
  "block.minecraft.banner.stripe_downleft.light_gray": "Klargriza diagonalo sinistra",
  "block.minecraft.banner.stripe_downleft.lime": "Klarverda diagonalo sinistra",
  "block.minecraft.banner.stripe_downleft.magenta": "Magenta diagonalo sinistra",
  "block.minecraft.banner.stripe_downleft.orange": "Oranjea diagonalo sinistra",
  "block.minecraft.banner.stripe_downleft.pink": "Rozea diagonalo sinistra",
  "block.minecraft.banner.stripe_downleft.purple": "Purpura diagonalo sinistra",
  "block.minecraft.banner.stripe_downleft.red": "Reda diagonalo sinistra",
  "block.minecraft.banner.stripe_downleft.white": "Blanka diagonalo sinistra",
  "block.minecraft.banner.stripe_downleft.yellow": "Flava diagonalo sinistra",
  "block.minecraft.banner.stripe_downright.black": "Nigra diagonalo dextra",
  "block.minecraft.banner.stripe_downright.blue": "Blua diagonalo dextra",
  "block.minecraft.banner.stripe_downright.brown": "Bruna diagonalo dextra",
  "block.minecraft.banner.stripe_downright.cyan": "Cyana diagonalo dextra",
  "block.minecraft.banner.stripe_downright.gray": "Griza diagonalo dextra",
  "block.minecraft.banner.stripe_downright.green": "Verda diagonalo dextra",
  "block.minecraft.banner.stripe_downright.light_blue": "Cielblua diagonalo dextra",
  "block.minecraft.banner.stripe_downright.light_gray": "Klargriza diagonalo dextra",
  "block.minecraft.banner.stripe_downright.lime": "Klarverda diagonalo dextra",
  "block.minecraft.banner.stripe_downright.magenta": "Magenta diagonalo dextra",
  "block.minecraft.banner.stripe_downright.orange": "Oranjea diagonalo dextra",
  "block.minecraft.banner.stripe_downright.pink": "Rozea diagonalo dextra",
  "block.minecraft.banner.stripe_downright.purple": "Purpura diagonalo dextra",
  "block.minecraft.banner.stripe_downright.red": "Reda diagonalo dextra",
  "block.minecraft.banner.stripe_downright.white": "Blanka diagonalo dextra",
  "block.minecraft.banner.stripe_downright.yellow": "Flava diagonalo dextra",
  "block.minecraft.banner.stripe_left.black": "Nigra strio dextra",
  "block.minecraft.banner.stripe_left.blue": "Blua strio dextra",
  "block.minecraft.banner.stripe_left.brown": "Bruna strio dextra",
  "block.minecraft.banner.stripe_left.cyan": "Cyana strio dextra",
  "block.minecraft.banner.stripe_left.gray": "Griza strio dextra",
  "block.minecraft.banner.stripe_left.green": "Verda strio dextra",
  "block.minecraft.banner.stripe_left.light_blue": "Cielblua strio dextra",
  "block.minecraft.banner.stripe_left.light_gray": "Klargriza strio dextra",
  "block.minecraft.banner.stripe_left.lime": "Klarverda strio dextra",
  "block.minecraft.banner.stripe_left.magenta": "Magenta strio dextra",
  "block.minecraft.banner.stripe_left.orange": "Oranjea strio dextra",
  "block.minecraft.banner.stripe_left.pink": "Rozea strio dextra",
  "block.minecraft.banner.stripe_left.purple": "Purpura strio dextra",
  "block.minecraft.banner.stripe_left.red": "Reda strio dextra",
  "block.minecraft.banner.stripe_left.white": "Blanka strio dextra",
  "block.minecraft.banner.stripe_left.yellow": "Flava strio dextra",
  "block.minecraft.banner.stripe_middle.black": "Nigra stango",
  "block.minecraft.banner.stripe_middle.blue": "Blua stango",
  "block.minecraft.banner.stripe_middle.brown": "Bruna stango",
  "block.minecraft.banner.stripe_middle.cyan": "Cyana stango",
  "block.minecraft.banner.stripe_middle.gray": "Griza stango",
  "block.minecraft.banner.stripe_middle.green": "Verda stango",
  "block.minecraft.banner.stripe_middle.light_blue": "Cielblua stango",
  "block.minecraft.banner.stripe_middle.light_gray": "Klargriza stango",
  "block.minecraft.banner.stripe_middle.lime": "Klarverda stango",
  "block.minecraft.banner.stripe_middle.magenta": "Magenta stango",
  "block.minecraft.banner.stripe_middle.orange": "Oranjea stango",
  "block.minecraft.banner.stripe_middle.pink": "Rozea stango",
  "block.minecraft.banner.stripe_middle.purple": "Purpura stango",
  "block.minecraft.banner.stripe_middle.red": "Reda stango",
  "block.minecraft.banner.stripe_middle.white": "Blanka stango",
  "block.minecraft.banner.stripe_middle.yellow": "Flava stango",
  "block.minecraft.banner.stripe_right.black": "Nigra strio sinistra",
  "block.minecraft.banner.stripe_right.blue": "Blua strio sinistra",
  "block.minecraft.banner.stripe_right.brown": "Bruna strio sinistra",
  "block.minecraft.banner.stripe_right.cyan": "Cyana strio sinistra",
  "block.minecraft.banner.stripe_right.gray": "Griza strio sinistra",
  "block.minecraft.banner.stripe_right.green": "Verda strio sinistra",
  "block.minecraft.banner.stripe_right.light_blue": "Cielblua strio sinistra",
  "block.minecraft.banner.stripe_right.light_gray": "Klargriza strio sinistra",
  "block.minecraft.banner.stripe_right.lime": "Klarverda strio sinistra",
  "block.minecraft.banner.stripe_right.magenta": "Magenta strio sinistra",
  "block.minecraft.banner.stripe_right.orange": "Oranjea strio sinistra",
  "block.minecraft.banner.stripe_right.pink": "Rozea strio sinistra",
  "block.minecraft.banner.stripe_right.purple": "Purpura strio sinistra",
  "block.minecraft.banner.stripe_right.red": "Reda strio sinistra",
  "block.minecraft.banner.stripe_right.white": "Blanka strio sinistra",
  "block.minecraft.banner.stripe_right.yellow": "Flava strio sinistra",
  "block.minecraft.banner.stripe_top.black": "Nigra chefo",
  "block.minecraft.banner.stripe_top.blue": "Blua chefo",
  "block.minecraft.banner.stripe_top.brown": "Bruna chefo",
  "block.minecraft.banner.stripe_top.cyan": "Ciana chefo",
  "block.minecraft.banner.stripe_top.gray": "Griza chefo",
  "block.minecraft.banner.stripe_top.green": "Verda chefo",
  "block.minecraft.banner.stripe_top.light_blue": "Cielblua chefo",
  "block.minecraft.banner.stripe_top.light_gray": "Klargriza chefo",
  "block.minecraft.banner.stripe_top.lime": "Klarverda chefo",
  "block.minecraft.banner.stripe_top.magenta": "Magenta chefo",
  "block.minecraft.banner.stripe_top.orange": "Oranjea chefo",
  "block.minecraft.banner.stripe_top.pink": "Rozea chefo",
  "block.minecraft.banner.stripe_top.purple": "Purpura chefo",
  "block.minecraft.banner.stripe_top.red": "Reda chefo",
  "block.minecraft.banner.stripe_top.white": "Blanka chefo",
  "block.minecraft.banner.stripe_top.yellow": "Flava chefo",
  "block.minecraft.banner.triangle_bottom.black": "Nigra chevrono infra",
  "block.minecraft.banner.triangle_bottom.blue": "Blua chevrono infra",
  "block.minecraft.banner.triangle_bottom.brown": "Bruna chevrono infra",
  "block.minecraft.banner.triangle_bottom.cyan": "Cyana chevrono infra",
  "block.minecraft.banner.triangle_bottom.gray": "Griza chevrono infra",
  "block.minecraft.banner.triangle_bottom.green": "Verda chevrono infra",
  "block.minecraft.banner.triangle_bottom.light_blue": "Cielblua chevrono infra",
  "block.minecraft.banner.triangle_bottom.light_gray": "Klargriza chevrono infra",
  "block.minecraft.banner.triangle_bottom.lime": "Klarverda chevrono infra",
  "block.minecraft.banner.triangle_bottom.magenta": "Magenta chevrono infra",
  "block.minecraft.banner.triangle_bottom.orange": "Oranjea chevrono infra",
  "block.minecraft.banner.triangle_bottom.pink": "Rozea chevrono infra",
  "block.minecraft.banner.triangle_bottom.purple": "Purpura chevrono infra",
  "block.minecraft.banner.triangle_bottom.red": "Reda chevrono infra",
  "block.minecraft.banner.triangle_bottom.white": "Blanka chevrono infra",
  "block.minecraft.banner.triangle_bottom.yellow": "Flava chevrono infra",
  "block.minecraft.banner.triangle_top.black": "Nigra chevrono supra",
  "block.minecraft.banner.triangle_top.blue": "Blua chevrono supra",
  "block.minecraft.banner.triangle_top.brown": "Bruna chevrono supra",
  "block.minecraft.banner.triangle_top.cyan": "Cyana chevrono supra",
  "block.minecraft.banner.triangle_top.gray": "Griza chevrono supra",
  "block.minecraft.banner.triangle_top.green": "Verda chevrono supra",
  "block.minecraft.banner.triangle_top.light_blue": "Cielblua chevrono supra",
  "block.minecraft.banner.triangle_top.light_gray": "Klargriza chevrono supra",
  "block.minecraft.banner.triangle_top.lime": "Klarverda chevrono supra",
  "block.minecraft.banner.triangle_top.magenta": "Magenta chevrono supra",
  "block.minecraft.banner.triangle_top.orange": "Oranjea chevrono supra",
  "block.minecraft.banner.triangle_top.pink": "Rozea chevrono supra",
  "block.minecraft.banner.triangle_top.purple": "Purpura chevrono supra",
  "block.minecraft.banner.triangle_top.red": "Reda chevrono supra",
  "block.minecraft.banner.triangle_top.white": "Blanka chevrono supra",
  "block.minecraft.banner.triangle_top.yellow": "Flava chevrono supra",
  "block.minecraft.banner.triangles_bottom.black": "Nigra denti infra",
  "block.minecraft.banner.triangles_bottom.blue": "Blua denti infra",
  "block.minecraft.banner.triangles_bottom.brown": "Bruna denti infra",
  "block.minecraft.banner.triangles_bottom.cyan": "Cyana denti infra",
  "block.minecraft.banner.triangles_bottom.gray": "Griza denti infra",
  "block.minecraft.banner.triangles_bottom.green": "Verda denti infra",
  "block.minecraft.banner.triangles_bottom.light_blue": "Cielblua denti infra",
  "block.minecraft.banner.triangles_bottom.light_gray": "Klargriza denti infra",
  "block.minecraft.banner.triangles_bottom.lime": "Klarverda denti infra",
  "block.minecraft.banner.triangles_bottom.magenta": "Magenta denti infra",
  "block.minecraft.banner.triangles_bottom.orange": "Oranjea denti infra",
  "block.minecraft.banner.triangles_bottom.pink": "Rozea denti infra",
  "block.minecraft.banner.triangles_bottom.purple": "Purpura denti infra",
  "block.minecraft.banner.triangles_bottom.red": "Reda denti infra",
  "block.minecraft.banner.triangles_bottom.white": "Blanka denti infra",
  "block.minecraft.banner.triangles_bottom.yellow": "Flava denti infra",
  "block.minecraft.banner.triangles_top.black": "Nigra denti supra",
  "block.minecraft.banner.triangles_top.blue": "Blua denti supra",
  "block.minecraft.banner.triangles_top.brown": "Bruna denti supra",
  "block.minecraft.banner.triangles_top.cyan": "Cyana denti supra",
  "block.minecraft.banner.triangles_top.gray": "Griza denti supra",
  "block.minecraft.banner.triangles_top.green": "Verda denti supra",
  "block.minecraft.banner.triangles_top.light_blue": "Cielblua denti supra",
  "block.minecraft.banner.triangles_top.light_gray": "Klargriza denti supra",
  "block.minecraft.banner.triangles_top.lime": "Klarverda denti supra",
  "block.minecraft.banner.triangles_top.magenta": "Magenta denti supra",
  "block.minecraft.banner.triangles_top.orange": "Oranjea denti supra",
  "block.minecraft.banner.triangles_top.pink": "Rozea denti supra",
  "block.minecraft.banner.triangles_top.purple": "Purpura denti supra",
  "block.minecraft.banner.triangles_top.red": "Reda denti supra",
  "block.minecraft.banner.triangles_top.white": "Blanka denti supra",
  "block.minecraft.banner.triangles_top.yellow": "Flava denti supra",
  "block.minecraft.barrel": "Barelo",
  "block.minecraft.barrier": "Barilo",
  "block.minecraft.basalt": "Bazalto",
  "block.minecraft.beacon": "Baliso",
  "block.minecraft.beacon.primary": "Povo prima",
  "block.minecraft.beacon.secondary": "Povo sekundara",
  "block.minecraft.bed.no_sleep": "Vu povas nur dormar ye nokto o dum sturmi",
  "block.minecraft.bed.not_safe": "Vu ne povas restar nun; monsteri esas proxima",
  "block.minecraft.bed.obstructed": "Ica lito esas inkombrata",
  "block.minecraft.bed.occupied": "Ica lito esas okupata",
  "block.minecraft.bed.too_far_away": "Vu ne darfas restar nun; la lito esas tro distanta",
  "block.minecraft.bedrock": "Bazpetro",
  "block.minecraft.bee_nest": "Abelnesto",
  "block.minecraft.beehive": "Abeluyo",
  "block.minecraft.beetroots": "Betravi",
  "block.minecraft.bell": "Klosho",
  "block.minecraft.big_dripleaf": "Gutofolio granda",
  "block.minecraft.big_dripleaf_stem": "Stipito di gutofolio granda",
  "block.minecraft.birch_button": "Butono birka",
  "block.minecraft.birch_door": "Pordo birka",
  "block.minecraft.birch_fence": "Fenco birka",
  "block.minecraft.birch_fence_gate": "Pordeto birka",
  "block.minecraft.birch_hanging_sign": "Pendanta signo birka",
  "block.minecraft.birch_leaves": "Folii birka",
  "block.minecraft.birch_log": "Lenio birka",
  "block.minecraft.birch_planks": "Planki birka",
  "block.minecraft.birch_pressure_plate": "Presoplako birka",
  "block.minecraft.birch_sapling": "Arboreto birka",
  "block.minecraft.birch_shelf": "Birch Shelf",
  "block.minecraft.birch_sign": "Signo birka",
  "block.minecraft.birch_slab": "Plako birka",
  "block.minecraft.birch_stairs": "Eskalero birka",
  "block.minecraft.birch_trapdoor": "Trapo birka",
  "block.minecraft.birch_wall_hanging_sign": "Murala pendanta signo birka",
  "block.minecraft.birch_wall_sign": "Murala signo birka",
  "block.minecraft.birch_wood": "Ligno birka",
  "block.minecraft.black_banner": "Nigra banero",
  "block.minecraft.black_bed": "Nigra lito",
  "block.minecraft.black_candle": "Nigra kandelo",
  "block.minecraft.black_candle_cake": "Kuko kun nigra kandelo",
  "block.minecraft.black_carpet": "Nigra tapiso",
  "block.minecraft.black_concrete": "Nigra betono",
  "block.minecraft.black_concrete_powder": "Nigra betonpulvero",
  "block.minecraft.black_glazed_terracotta": "Nigra terakoto glezita",
  "block.minecraft.black_shulker_box": "Nigra buxo di Shulkero",
  "block.minecraft.black_stained_glass": "Nigra vitro tintita",
  "block.minecraft.black_stained_glass_pane": "Nigra vitrokarelo tintita",
  "block.minecraft.black_terracotta": "Nigra terakoto",
  "block.minecraft.black_wool": "Nigra lano",
  "block.minecraft.blackstone": "Nigrapetro",
  "block.minecraft.blackstone_slab": "Plako di Nigrapetro",
  "block.minecraft.blackstone_stairs": "Eskalero di nigrapetro",
  "block.minecraft.blackstone_wall": "Muro di nigrapetro",
  "block.minecraft.blast_furnace": "Fornego",
  "block.minecraft.blue_banner": "Blua banero",
  "block.minecraft.blue_bed": "Blua lito",
  "block.minecraft.blue_candle": "Blua kandelo",
  "block.minecraft.blue_candle_cake": "Kuko kun blua kandelo",
  "block.minecraft.blue_carpet": "Blua tapiso",
  "block.minecraft.blue_concrete": "Blua betono",
  "block.minecraft.blue_concrete_powder": "Blua betonpulvero",
  "block.minecraft.blue_glazed_terracotta": "Blua terakoto glezita",
  "block.minecraft.blue_ice": "Glacio blua",
  "block.minecraft.blue_orchid": "Orkideo blua",
  "block.minecraft.blue_shulker_box": "Blua buxo di Shulkero",
  "block.minecraft.blue_stained_glass": "Blua vitro tintita",
  "block.minecraft.blue_stained_glass_pane": "Blua vitrokarelo tintita",
  "block.minecraft.blue_terracotta": "Blua terakoto",
  "block.minecraft.blue_wool": "Blua lano",
  "block.minecraft.bone_block": "Bloko di osto",
  "block.minecraft.bookshelf": "Biblioteko",
  "block.minecraft.brain_coral": "Cerebrala koralio",
  "block.minecraft.brain_coral_block": "Bloko di cerebrala koralio",
  "block.minecraft.brain_coral_fan": "Fano di cerebrala koralio",
  "block.minecraft.brain_coral_wall_fan": "Murala fano di cerebrala koralio",
  "block.minecraft.brewing_stand": "Brasostativo",
  "block.minecraft.brick_slab": "Plako di briko",
  "block.minecraft.brick_stairs": "Eskalero di briko",
  "block.minecraft.brick_wall": "Muro di briki",
  "block.minecraft.bricks": "Briki",
  "block.minecraft.brown_banner": "Bruna banero",
  "block.minecraft.brown_bed": "Bruna lito",
  "block.minecraft.brown_candle": "Bruna kandelo",
  "block.minecraft.brown_candle_cake": "Kuko kun bruna kandelo",
  "block.minecraft.brown_carpet": "Bruna tapiso",
  "block.minecraft.brown_concrete": "Bruna betono",
  "block.minecraft.brown_concrete_powder": "Bruna betonpulvero",
  "block.minecraft.brown_glazed_terracotta": "Bruna terakoto glezita",
  "block.minecraft.brown_mushroom": "Fungo bruna",
  "block.minecraft.brown_mushroom_block": "Bloko di fungo bruna",
  "block.minecraft.brown_shulker_box": "Bruna buxo di Shulkero",
  "block.minecraft.brown_stained_glass": "Bruna vitro tintita",
  "block.minecraft.brown_stained_glass_pane": "Bruna vitrokarelo tintita",
  "block.minecraft.brown_terracotta": "Bruna terakoto",
  "block.minecraft.brown_wool": "Bruna lano",
  "block.minecraft.bubble_column": "Kolono di spumo",
  "block.minecraft.bubble_coral": "Buleta koralio",
  "block.minecraft.bubble_coral_block": "Bloko di buleta koralio",
  "block.minecraft.bubble_coral_fan": "Fano di buleta koralio",
  "block.minecraft.bubble_coral_wall_fan": "Murala fano di buleta koralio",
  "block.minecraft.budding_amethyst": "Ametisto burjonifanta",
  "block.minecraft.bush": "Arbusto",
  "block.minecraft.cactus": "Kaktuso",
  "block.minecraft.cactus_flower": "Cactus Flower",
  "block.minecraft.cake": "Kuko",
  "block.minecraft.calcite": "Kalcito",
  "block.minecraft.calibrated_sculk_sensor": "Kalibrigita Sculk-sensoro",
  "block.minecraft.campfire": "Kampfairo",
  "block.minecraft.candle": "Kandelo",
  "block.minecraft.candle_cake": "Kuko kun kandelo",
  "block.minecraft.carrots": "Karoti",
  "block.minecraft.cartography_table": "Tablo di kartografio",
  "block.minecraft.carved_pumpkin": "Skultata kukurbito",
  "block.minecraft.cauldron": "Kaldrono",
  "block.minecraft.cave_air": "Aero kavernala",
  "block.minecraft.cave_vines": "Kavkreskoj",
  "block.minecraft.cave_vines_plant": "Kavkreska planto",
  "block.minecraft.chain": "Katenar",
  "block.minecraft.chain_command_block": "Bloko di komandi katenita",
  "block.minecraft.cherry_button": "Ĉeriza butono",
  "block.minecraft.cherry_door": "Ĉeriza pordo",
  "block.minecraft.cherry_fence": "Ĉeriza barilo",
  "block.minecraft.cherry_fence_gate": "Ĉeriza pordbarilo",
  "block.minecraft.cherry_hanging_sign": "Ĉeriza pendanta signo",
  "block.minecraft.cherry_leaves": "Ĉerizaj folioj",
  "block.minecraft.cherry_log": "Ĉeriza ligno",
  "block.minecraft.cherry_planks": "Ĉerizaj tabuloj",
  "block.minecraft.cherry_pressure_plate": "Ĉeriza prem-plato",
  "block.minecraft.cherry_sapling": "Ĉeriza plantido",
  "block.minecraft.cherry_shelf": "Cherry Shelf",
  "block.minecraft.cherry_sign": "Ĉeriza signo",
  "block.minecraft.cherry_slab": "Ĉeriza tavolo",
  "block.minecraft.cherry_stairs": "Kirsan Ŝtuparoj",
  "block.minecraft.cherry_trapdoor": "Kirsan Kaptraporto",
  "block.minecraft.cherry_wall_hanging_sign": "Tabulo sur muro kun bildeto de kirsoj",
  "block.minecraft.cherry_wall_sign": "Kirsan Mura Signo",
  "block.minecraft.cherry_wood": "Kirsan Ligno",
  "block.minecraft.chest": "Kofro",
  "block.minecraft.chipped_anvil": "Amboso ruptetita",
  "block.minecraft.chiseled_bookshelf": "Biblioteko cizelita",
  "block.minecraft.chiseled_copper": "Kizita Kupro",
  "block.minecraft.chiseled_deepslate": "Profundardezo cizelita",
  "block.minecraft.chiseled_nether_bricks": "Netherbriki cizelita",
  "block.minecraft.chiseled_polished_blackstone": "Polisita nigrapetro cizelita",
  "block.minecraft.chiseled_quartz_block": "Bloko di quarco cizelita",
  "block.minecraft.chiseled_red_sandstone": "Reda greso cizelita",
  "block.minecraft.chiseled_resin_bricks": "Chiseled Resin Bricks",
  "block.minecraft.chiseled_sandstone": "Greso cizelita",
  "block.minecraft.chiseled_stone_bricks": "Petrabriki cizelita",
  "block.minecraft.chiseled_tuff": "Kizita Tufa",
  "block.minecraft.chiseled_tuff_bricks": "Kizitaj Tufaj Brikoj",
  "block.minecraft.chorus_flower": "Chorusfloro",
  "block.minecraft.chorus_plant": "Chorusplanto",
  "block.minecraft.clay": "Argilo",
  "block.minecraft.closed_eyeblossom": "Closed Eyeblossom",
  "block.minecraft.coal_block": "Bloko di karbono",
  "block.minecraft.coal_ore": "Erco di karbono",
  "block.minecraft.coarse_dirt": "Sulo grosiera",
  "block.minecraft.cobbled_deepslate": "Profundardezo eskombra",
  "block.minecraft.cobbled_deepslate_slab": "Plako di profundardezo eskombra",
  "block.minecraft.cobbled_deepslate_stairs": "Eskalero di profundardezo eskombra",
  "block.minecraft.cobbled_deepslate_wall": "Muro di profundardezo eskombra",
  "block.minecraft.cobblestone": "Eskombro",
  "block.minecraft.cobblestone_slab": "Plako di eskombro",
  "block.minecraft.cobblestone_stairs": "Eskalero di eskombro",
  "block.minecraft.cobblestone_wall": "Muro di eskombro",
  "block.minecraft.cobweb": "Aranereto",
  "block.minecraft.cocoa": "Kakao",
  "block.minecraft.command_block": "Bloko di komandi",
  "block.minecraft.comparator": "Komparilo di redstoneo",
  "block.minecraft.composter": "Dungilo",
  "block.minecraft.conduit": "Povoduktilo",
  "block.minecraft.copper_bars": "Copper Bars",
  "block.minecraft.copper_block": "Bloko di kupro",
  "block.minecraft.copper_bulb": "Kupra Bulbo",
  "block.minecraft.copper_chain": "Copper Chain",
  "block.minecraft.copper_chest": "Copper Chest",
  "block.minecraft.copper_door": "Kupra Pordo",
  "block.minecraft.copper_golem_statue": "Copper Golem Statue",
  "block.minecraft.copper_grate": "Kupra Krado",
  "block.minecraft.copper_lantern": "Copper Lantern",
  "block.minecraft.copper_ore": "Erco di kupro",
  "block.minecraft.copper_torch": "Copper Torch",
  "block.minecraft.copper_trapdoor": "Kupra Kaptraporto",
  "block.minecraft.copper_wall_torch": "Copper Wall Torch",
  "block.minecraft.cornflower": "Aciano",
  "block.minecraft.cracked_deepslate_bricks": "Briki profundardeza krakita",
  "block.minecraft.cracked_deepslate_tiles": "Teguli profundardeza krakita",
  "block.minecraft.cracked_nether_bricks": "Netherbriki krakita",
  "block.minecraft.cracked_polished_blackstone_bricks": "Polisita briki nigrapetra krakita",
  "block.minecraft.cracked_stone_bricks": "Petrabriko krakita",
  "block.minecraft.crafter": "Metisto",
  "block.minecraft.crafting_table": "Tablo di fabrikado",
  "block.minecraft.creaking_heart": "Creaking Heart",
  "block.minecraft.creeper_head": "Kapo di creepero",
  "block.minecraft.creeper_wall_head": "Murala kapo di creepero",
  "block.minecraft.crimson_button": "Butono karmezina",
  "block.minecraft.crimson_door": "Pordo karmezina",
  "block.minecraft.crimson_fence": "Fenco karmezina",
  "block.minecraft.crimson_fence_gate": "Pordeto karmezina",
  "block.minecraft.crimson_fungus": "Fungo karmezina",
  "block.minecraft.crimson_hanging_sign": "Pendanta signo karmezina",
  "block.minecraft.crimson_hyphae": "Hyfei karmezina",
  "block.minecraft.crimson_nylium": "Nylio karmezina",
  "block.minecraft.crimson_planks": "Planki karmezina",
  "block.minecraft.crimson_pressure_plate": "Presoplako karmezina",
  "block.minecraft.crimson_roots": "Radiki karmezina",
  "block.minecraft.crimson_shelf": "Crimson Shelf",
  "block.minecraft.crimson_sign": "Signo karmezina",
  "block.minecraft.crimson_slab": "Plako karmezina",
  "block.minecraft.crimson_stairs": "Eskalero karmezina",
  "block.minecraft.crimson_stem": "Stipo karmezina",
  "block.minecraft.crimson_trapdoor": "Trapo karmezina",
  "block.minecraft.crimson_wall_hanging_sign": "Murala pendanta signo karmezina",
  "block.minecraft.crimson_wall_sign": "Murala signo karmezina",
  "block.minecraft.crying_obsidian": "Obsidiano ploranta",
  "block.minecraft.cut_copper": "Kupro tailita",
  "block.minecraft.cut_copper_slab": "Plako kupra tailita",
  "block.minecraft.cut_copper_stairs": "Eskalero kupra tailita",
  "block.minecraft.cut_red_sandstone": "Reda greso tailita",
  "block.minecraft.cut_red_sandstone_slab": "Plako di reda greso tailita",
  "block.minecraft.cut_sandstone": "Greso tailita",
  "block.minecraft.cut_sandstone_slab": "Plako di greso tailita",
  "block.minecraft.cyan_banner": "Cyana banero",
  "block.minecraft.cyan_bed": "Cyana lito",
  "block.minecraft.cyan_candle": "Cyana kandelo",
  "block.minecraft.cyan_candle_cake": "Kuko kun cyana kandelo",
  "block.minecraft.cyan_carpet": "Cyana tapiso",
  "block.minecraft.cyan_concrete": "Cyana betono",
  "block.minecraft.cyan_concrete_powder": "Cyana betonpulvero",
  "block.minecraft.cyan_glazed_terracotta": "Cyana terakoto glezita",
  "block.minecraft.cyan_shulker_box": "Cyana buxo di Shulkero",
  "block.minecraft.cyan_stained_glass": "Cyana vitro tintita",
  "block.minecraft.cyan_stained_glass_pane": "Cyana vitrokarelo tintita",
  "block.minecraft.cyan_terracotta": "Cyana terakoto",
  "block.minecraft.cyan_wool": "Cyana lano",
  "block.minecraft.damaged_anvil": "Amboso domajita",
  "block.minecraft.dandelion": "Leondento",
  "block.minecraft.dark_oak_button": "Butono obskurquerka",
  "block.minecraft.dark_oak_door": "Pordo obskurquerka",
  "block.minecraft.dark_oak_fence": "Fenco obskurquerka",
  "block.minecraft.dark_oak_fence_gate": "Pordeto obskurquerka",
  "block.minecraft.dark_oak_hanging_sign": "Pendanta signo obskurquerka",
  "block.minecraft.dark_oak_leaves": "Folii obskurquerka",
  "block.minecraft.dark_oak_log": "Lenio obskurquerka",
  "block.minecraft.dark_oak_planks": "Planki obskurquerka",
  "block.minecraft.dark_oak_pressure_plate": "Presoplako obskurquerka",
  "block.minecraft.dark_oak_sapling": "Aboreto obskurquerka",
  "block.minecraft.dark_oak_shelf": "Dark Oak Shelf",
  "block.minecraft.dark_oak_sign": "Signo obskurquerka",
  "block.minecraft.dark_oak_slab": "Plako obskurquerka",
  "block.minecraft.dark_oak_stairs": "Eskalero obskurquerka",
  "block.minecraft.dark_oak_trapdoor": "Trapo obskurquerka",
  "block.minecraft.dark_oak_wall_hanging_sign": "Murala pendanta signo obskurquerka",
  "block.minecraft.dark_oak_wall_sign": "Murala signo obskurquerka",
  "block.minecraft.dark_oak_wood": "Ligno obskurquerka",
  "block.minecraft.dark_prismarine": "Prismarino obskura",
  "block.minecraft.dark_prismarine_slab": "Plako di prismarino obskura",
  "block.minecraft.dark_prismarine_stairs": "Eskalero di prismarino obskura",
  "block.minecraft.daylight_detector": "Detektanto di dilumo",
  "block.minecraft.dead_brain_coral": "Cerebrala koralio mortinta",
  "block.minecraft.dead_brain_coral_block": "Bloko di cerebrala koralio mortinta",
  "block.minecraft.dead_brain_coral_fan": "Fano di cerebrala koralio mortinta",
  "block.minecraft.dead_brain_coral_wall_fan": "Murala fano di cerebrala koralio mortinta",
  "block.minecraft.dead_bubble_coral": "Buleta koralio mortinta",
  "block.minecraft.dead_bubble_coral_block": "Bloko di buleta koralio mortinta",
  "block.minecraft.dead_bubble_coral_fan": "Fano di buleta koralio mortinta",
  "block.minecraft.dead_bubble_coral_wall_fan": "Murala fano di buleta koralio mortinta",
  "block.minecraft.dead_bush": "Arbusto mortinta",
  "block.minecraft.dead_fire_coral": "Fairala koralio mortinta",
  "block.minecraft.dead_fire_coral_block": "Bloko di fairala koralio mortinta",
  "block.minecraft.dead_fire_coral_fan": "Fano di fairala koralio mortinta",
  "block.minecraft.dead_fire_coral_wall_fan": "Murala fano di fairala koralio mortinta",
  "block.minecraft.dead_horn_coral": "Korna koralio mortinta",
  "block.minecraft.dead_horn_coral_block": "Bloko di korna koralio mortinta",
  "block.minecraft.dead_horn_coral_fan": "Fano di korna koralio mortinta",
  "block.minecraft.dead_horn_coral_wall_fan": "Murala fano di korna koralio mortinta",
  "block.minecraft.dead_tube_coral": "Pipeta koralio mortinta",
  "block.minecraft.dead_tube_coral_block": "Bloko di pipeta koralio mortinta",
  "block.minecraft.dead_tube_coral_fan": "Fano di pipeta koralio mortinta",
  "block.minecraft.dead_tube_coral_wall_fan": "Murala fano di pipeta koralio mortinta",
  "block.minecraft.decorated_pot": "Ornamentita Poto",
  "block.minecraft.deepslate": "Profundardezo",
  "block.minecraft.deepslate_brick_slab": "Plako di briko profundardeza",
  "block.minecraft.deepslate_brick_stairs": "Eskalero di briko profundardeza",
  "block.minecraft.deepslate_brick_wall": "Muro di briko profundardeza",
  "block.minecraft.deepslate_bricks": "Briki profundardeza",
  "block.minecraft.deepslate_coal_ore": "Erco profundardeza di karbono",
  "block.minecraft.deepslate_copper_ore": "Erco profundardeza di kupro",
  "block.minecraft.deepslate_diamond_ore": "Erco profundardeza di diamanto",
  "block.minecraft.deepslate_emerald_ore": "Erco profundardeza di smeraldo",
  "block.minecraft.deepslate_gold_ore": "Erco profundardeza di oro",
  "block.minecraft.deepslate_iron_ore": "Erco profundardeza di fero",
  "block.minecraft.deepslate_lapis_ore": "Erco profundardeza di lapislazulo",
  "block.minecraft.deepslate_redstone_ore": "Erco profundardeza di redstoneo",
  "block.minecraft.deepslate_tile_slab": "Plako di tegulo profundardeza",
  "block.minecraft.deepslate_tile_stairs": "Eskalero di tegulo profundardeza",
  "block.minecraft.deepslate_tile_wall": "Muro di tegulo profundardeza",
  "block.minecraft.deepslate_tiles": "Teguli profundardeza",
  "block.minecraft.detector_rail": "Ralo di detekteso",
  "block.minecraft.diamond_block": "Bloko di diamanto",
  "block.minecraft.diamond_ore": "Erco di diamanto",
  "block.minecraft.diorite": "Diorito",
  "block.minecraft.diorite_slab": "Plako diorita",
  "block.minecraft.diorite_stairs": "Eskalero diorita",
  "block.minecraft.diorite_wall": "Muro diorita",
  "block.minecraft.dirt": "Sulo",
  "block.minecraft.dirt_path": "Voyo di sulo",
  "block.minecraft.dispenser": "Lansilo",
  "block.minecraft.dragon_egg": "Ovo di drako",
  "block.minecraft.dragon_head": "Kapo di drako",
  "block.minecraft.dragon_wall_head": "Murala kapo di drako",
  "block.minecraft.dried_ghast": "Dried Ghast",
  "block.minecraft.dried_kelp_block": "Bloko di algo sika",
  "block.minecraft.dripstone_block": "Bloko di gutopetro",
  "block.minecraft.dropper": "Distributilo",
  "block.minecraft.emerald_block": "Bloko di smeraldo",
  "block.minecraft.emerald_ore": "Erco di smeraldo",
  "block.minecraft.enchanting_table": "Sorcotablo",
  "block.minecraft.end_gateway": "Pordeyo di End",
  "block.minecraft.end_portal": "Portalo di End",
  "block.minecraft.end_portal_frame": "Portalframo di End",
  "block.minecraft.end_rod": "Bastono di End",
  "block.minecraft.end_stone": "Petro di End",
  "block.minecraft.end_stone_brick_slab": "Plako di petrabriki di End",
  "block.minecraft.end_stone_brick_stairs": "Eskalero di petrabriki di End",
  "block.minecraft.end_stone_brick_wall": "Muro di petrabriki di End",
  "block.minecraft.end_stone_bricks": "Petrabriki di End",
  "block.minecraft.ender_chest": "Enderkofro",
  "block.minecraft.exposed_chiseled_copper": "Esponita Kizita Kupro",
  "block.minecraft.exposed_copper": "Kupro expozita",
  "block.minecraft.exposed_copper_bars": "Exposed Copper Bars",
  "block.minecraft.exposed_copper_bulb": "Esponita Kupra Bulbo",
  "block.minecraft.exposed_copper_chain": "Exposed Copper Chain",
  "block.minecraft.exposed_copper_chest": "Exposed Copper Chest",
  "block.minecraft.exposed_copper_door": "Esponita Kupra Pordo",
  "block.minecraft.exposed_copper_golem_statue": "Exposed Copper Golem Statue",
  "block.minecraft.exposed_copper_grate": "Esponita Kupra Krado",
  "block.minecraft.exposed_copper_lantern": "Exposed Copper Lantern",
  "block.minecraft.exposed_copper_trapdoor": "Esponita Kupra Kaptraporto",
  "block.minecraft.exposed_cut_copper": "Kupro expozita tailita",
  "block.minecraft.exposed_cut_copper_slab": "Plako kupra expozita tailita",
  "block.minecraft.exposed_cut_copper_stairs": "Eskalero kupra expozita tailita",
  "block.minecraft.exposed_lightning_rod": "Exposed Lightning Rod",
  "block.minecraft.farmland": "Farmsulo",
  "block.minecraft.fern": "Filiko",
  "block.minecraft.fire": "Fairo",
  "block.minecraft.fire_coral": "Fairala koralio",
  "block.minecraft.fire_coral_block": "Bloko di fairala koralio",
  "block.minecraft.fire_coral_fan": "Fano di fairala koralio",
  "block.minecraft.fire_coral_wall_fan": "Murala fano di fairala koralio",
  "block.minecraft.firefly_bush": "Firefly Bush",
  "block.minecraft.fletching_table": "Tablo di flechado",
  "block.minecraft.flower_pot": "Florpoto",
  "block.minecraft.flowering_azalea": "Florifanta azaleo",
  "block.minecraft.flowering_azalea_leaves": "Florifanta folii azalea",
  "block.minecraft.frogspawn": "Ranfrayo",
  "block.minecraft.frosted_ice": "Glacio pruinoza",
  "block.minecraft.furnace": "Furnazo",
  "block.minecraft.gilded_blackstone": "Orizita nigrapetro",
  "block.minecraft.glass": "Vitro",
  "block.minecraft.glass_pane": "Vitrokarelo",
  "block.minecraft.glow_lichen": "Lumlikeno",
  "block.minecraft.glowstone": "Lumpetro",
  "block.minecraft.gold_block": "Bloko di oro",
  "block.minecraft.gold_ore": "Erco di oro",
  "block.minecraft.golden_dandelion": "Golden Dandelion",
  "block.minecraft.granite": "Granito",
  "block.minecraft.granite_slab": "Plako granita",
  "block.minecraft.granite_stairs": "Eskalero granita",
  "block.minecraft.granite_wall": "Muro granita",
  "block.minecraft.grass": "Herbo",
  "block.minecraft.grass_block": "Bloko di gazono",
  "block.minecraft.gravel": "Gravio",
  "block.minecraft.gray_banner": "Griza banero",
  "block.minecraft.gray_bed": "Griza lito",
  "block.minecraft.gray_candle": "Griza kandelo",
  "block.minecraft.gray_candle_cake": "Kuko kun griza kandelo",
  "block.minecraft.gray_carpet": "Griza tapiso",
  "block.minecraft.gray_concrete": "Griza betono",
  "block.minecraft.gray_concrete_powder": "Griza betonpulvero",
  "block.minecraft.gray_glazed_terracotta": "Griza terakoto glezita",
  "block.minecraft.gray_shulker_box": "Griza buxo di Shulkero",
  "block.minecraft.gray_stained_glass": "Griza vitro tintita",
  "block.minecraft.gray_stained_glass_pane": "Griza vitrokarelo tintita",
  "block.minecraft.gray_terracotta": "Griza terakoto",
  "block.minecraft.gray_wool": "Griza lano",
  "block.minecraft.green_banner": "Verda banero",
  "block.minecraft.green_bed": "Verda lito",
  "block.minecraft.green_candle": "Verda kandelo",
  "block.minecraft.green_candle_cake": "Kuko kun verda kandelo",
  "block.minecraft.green_carpet": "Verda tapiso",
  "block.minecraft.green_concrete": "Verda betono",
  "block.minecraft.green_concrete_powder": "Verda betonpulvero",
  "block.minecraft.green_glazed_terracotta": "Verda terakoto glezita",
  "block.minecraft.green_shulker_box": "Verda buxo di Shulkero",
  "block.minecraft.green_stained_glass": "Verda vitro tintita",
  "block.minecraft.green_stained_glass_pane": "Verda vitrokarelo tintita",
  "block.minecraft.green_terracotta": "Verda terakoto",
  "block.minecraft.green_wool": "Verda lano",
  "block.minecraft.grindstone": "Grindstono",
  "block.minecraft.hanging_roots": "Radiki pendanta",
  "block.minecraft.hay_block": "Bloko di feno",
  "block.minecraft.heavy_core": "Pesa Kerno",
  "block.minecraft.heavy_weighted_pressure_plate": "Grava presoplako pezanta",
  "block.minecraft.honey_block": "Bloko di mielo",
  "block.minecraft.honeycomb_block": "Bloko di vabo",
  "block.minecraft.hopper": "Funelego",
  "block.minecraft.horn_coral": "Korna koralio",
  "block.minecraft.horn_coral_block": "Bloko di korna koralio",
  "block.minecraft.horn_coral_fan": "Fano di korna koralio",
  "block.minecraft.horn_coral_wall_fan": "Murala fano di korna koralio",
  "block.minecraft.ice": "Glacio",
  "block.minecraft.infested_chiseled_stone_bricks": "Infestita petrabriki cizelita",
  "block.minecraft.infested_cobblestone": "Infestita eskombro",
  "block.minecraft.infested_cracked_stone_bricks": "Infestita petrabriki krakita",
  "block.minecraft.infested_deepslate": "Infestita profundardezo",
  "block.minecraft.infested_mossy_stone_bricks": "Infestita petrabriki muskoza",
  "block.minecraft.infested_stone": "Infestita petro",
  "block.minecraft.infested_stone_bricks": "Infestita petrabriki",
  "block.minecraft.iron_bars": "Greto fera",
  "block.minecraft.iron_block": "Bloko di fero",
  "block.minecraft.iron_chain": "Iron Chain",
  "block.minecraft.iron_door": "Pordo fera",
  "block.minecraft.iron_ore": "Erco di fero",
  "block.minecraft.iron_trapdoor": "Trapo fera",
  "block.minecraft.jack_o_lantern": "Kukurbita lanterno",
  "block.minecraft.jigsaw": "Konstruktbloko",
  "block.minecraft.jukebox": "Muzikbuxo",
  "block.minecraft.jungle_button": "Butono mahagoniera",
  "block.minecraft.jungle_door": "Pordo mahagoniera",
  "block.minecraft.jungle_fence": "Fenco mahagoniera",
  "block.minecraft.jungle_fence_gate": "Pordeto mahagoniera",
  "block.minecraft.jungle_hanging_sign": "Pendanta signo mahagoniera",
  "block.minecraft.jungle_leaves": "Folii mahagoniera",
  "block.minecraft.jungle_log": "Lenio mahagoniera",
  "block.minecraft.jungle_planks": "Planki mahagoniera",
  "block.minecraft.jungle_pressure_plate": "Presoplako mahagoniera",
  "block.minecraft.jungle_sapling": "Arboreto mahagoniera",
  "block.minecraft.jungle_shelf": "Jungla Planko",
  "block.minecraft.jungle_sign": "Signo mahagoniera",
  "block.minecraft.jungle_slab": "Plako mahagoniera",
  "block.minecraft.jungle_stairs": "Eskalero mahagoniera",
  "block.minecraft.jungle_trapdoor": "Trapo mahagoniera",
  "block.minecraft.jungle_wall_hanging_sign": "Murala pendanta signo mahagoniera",
  "block.minecraft.jungle_wall_sign": "Murala signo mahagoniera",
  "block.minecraft.jungle_wood": "Ligno mahagoniera",
  "block.minecraft.kelp": "Algo",
  "block.minecraft.kelp_plant": "Planto di algo",
  "block.minecraft.ladder": "Skalo",
  "block.minecraft.lantern": "Lanterno",
  "block.minecraft.lapis_block": "Bloko di lapislazulo",
  "block.minecraft.lapis_ore": "Erco di lapislazulo",
  "block.minecraft.large_amethyst_bud": "Granda burjono ametista",
  "block.minecraft.large_fern": "Filikego",
  "block.minecraft.lava": "Lavao",
  "block.minecraft.lava_cauldron": "Kaldrono di lavao",
  "block.minecraft.leaf_litter": "Leaf Litter",
  "block.minecraft.lectern": "Libropupitro",
  "block.minecraft.lever": "Levero",
  "block.minecraft.light": "Lumo",
  "block.minecraft.light_blue_banner": "Cielblua banero",
  "block.minecraft.light_blue_bed": "Cielblua lito",
  "block.minecraft.light_blue_candle": "Cielblua kandelo",
  "block.minecraft.light_blue_candle_cake": "Kuko kun cielblua kandelo",
  "block.minecraft.light_blue_carpet": "Cielblua tapiso",
  "block.minecraft.light_blue_concrete": "Cielblua betono",
  "block.minecraft.light_blue_concrete_powder": "Cielblua betonpulvero",
  "block.minecraft.light_blue_glazed_terracotta": "Cielblua terakoto glezita",
  "block.minecraft.light_blue_shulker_box": "Cielblua buxo di Shulkero",
  "block.minecraft.light_blue_stained_glass": "Cielblua vitro tintita",
  "block.minecraft.light_blue_stained_glass_pane": "Cielblua vitrokarelo tintita",
  "block.minecraft.light_blue_terracotta": "Cielblua terakoto",
  "block.minecraft.light_blue_wool": "Cielblua lano",
  "block.minecraft.light_gray_banner": "Klargriza banero",
  "block.minecraft.light_gray_bed": "Klargriza lito",
  "block.minecraft.light_gray_candle": "Klargriza kandelo",
  "block.minecraft.light_gray_candle_cake": "Kuko kun klargriza kandelo",
  "block.minecraft.light_gray_carpet": "Klargriza tapiso",
  "block.minecraft.light_gray_concrete": "Klargriza betono",
  "block.minecraft.light_gray_concrete_powder": "Klargriza betonpulvero",
  "block.minecraft.light_gray_glazed_terracotta": "Klargriza terakoto glezita",
  "block.minecraft.light_gray_shulker_box": "Klargriza buxo di Shulkero",
  "block.minecraft.light_gray_stained_glass": "Klargriza vitro tintita",
  "block.minecraft.light_gray_stained_glass_pane": "Klargriza vitrokarelo tintita",
  "block.minecraft.light_gray_terracotta": "Klargriza terakoto",
  "block.minecraft.light_gray_wool": "Klargriza lano",
  "block.minecraft.light_weighted_pressure_plate": "Lejera presoplako pezanta",
  "block.minecraft.lightning_rod": "Parafulmino",
  "block.minecraft.lilac": "Lilaco",
  "block.minecraft.lily_of_the_valley": "Maifloro",
  "block.minecraft.lily_pad": "Nenufaro",
  "block.minecraft.lime_banner": "Klarverda banero",
  "block.minecraft.lime_bed": "Klarverda lito",
  "block.minecraft.lime_candle": "Klarverda kandelo",
  "block.minecraft.lime_candle_cake": "Kuko kun klarverda kandelo",
  "block.minecraft.lime_carpet": "Klarverda tapiso",
  "block.minecraft.lime_concrete": "Klarverda betono",
  "block.minecraft.lime_concrete_powder": "Klarverda betonpulvero",
  "block.minecraft.lime_glazed_terracotta": "Klarverda terakoto glezita",
  "block.minecraft.lime_shulker_box": "Klarverda buxo di Shulkero",
  "block.minecraft.lime_stained_glass": "Klarverda vitro tintita",
  "block.minecraft.lime_stained_glass_pane": "Klarverda vitrokarelo tintita",
  "block.minecraft.lime_terracotta": "Klarverda terakoto",
  "block.minecraft.lime_wool": "Klarverda lano",
  "block.minecraft.lodestone": "Magnetstono",
  "block.minecraft.loom": "Texilo",
  "block.minecraft.magenta_banner": "Magenta banero",
  "block.minecraft.magenta_bed": "Magenta lito",
  "block.minecraft.magenta_candle": "Magenta kandelo",
  "block.minecraft.magenta_candle_cake": "Kuko kun magenta kandelo",
  "block.minecraft.magenta_carpet": "Magenta tapiso",
  "block.minecraft.magenta_concrete": "Magenta betono",
  "block.minecraft.magenta_concrete_powder": "Magenta betonpulvero",
  "block.minecraft.magenta_glazed_terracotta": "Magenta terakoto glezita",
  "block.minecraft.magenta_shulker_box": "Magenta buxo di Shulkero",
  "block.minecraft.magenta_stained_glass": "Magenta vitro tintita",
  "block.minecraft.magenta_stained_glass_pane": "Magenta vitrokarelo tintita",
  "block.minecraft.magenta_terracotta": "Magenta terakoto",
  "block.minecraft.magenta_wool": "Magenta lano",
  "block.minecraft.magma_block": "Bloko di magmo",
  "block.minecraft.mangrove_button": "Butono mangliera",
  "block.minecraft.mangrove_door": "Pordo mangliera",
  "block.minecraft.mangrove_fence": "Fenco mangliera",
  "block.minecraft.mangrove_fence_gate": "Pordeto mangliera",
  "block.minecraft.mangrove_hanging_sign": "Pendanta signo mangliera",
  "block.minecraft.mangrove_leaves": "Folii mangliera",
  "block.minecraft.mangrove_log": "Lenio mangliera",
  "block.minecraft.mangrove_planks": "Planki mangliera",
  "block.minecraft.mangrove_pressure_plate": "Presoplako mangliera",
  "block.minecraft.mangrove_propagule": "Propagulo mangliera",
  "block.minecraft.mangrove_roots": "Radiki mangliera",
  "block.minecraft.mangrove_shelf": "Mangrove Shelf",
  "block.minecraft.mangrove_sign": "Signo mangliera",
  "block.minecraft.mangrove_slab": "Plako mangliera",
  "block.minecraft.mangrove_stairs": "Eskalero mangliera",
  "block.minecraft.mangrove_trapdoor": "Trapo mangliera",
  "block.minecraft.mangrove_wall_hanging_sign": "Murala pendanta signo mangliera",
  "block.minecraft.mangrove_wall_sign": "Murala signo mangliera",
  "block.minecraft.mangrove_wood": "Ligno mangliera",
  "block.minecraft.medium_amethyst_bud": "Mezagranda burjono ametista",
  "block.minecraft.melon": "Melono",
  "block.minecraft.melon_stem": "Melonstipito",
  "block.minecraft.moss_block": "Bloko di musko",
  "block.minecraft.moss_carpet": "Tapiso di musko",
  "block.minecraft.mossy_cobblestone": "Eskombro muskoza",
  "block.minecraft.mossy_cobblestone_slab": "Plako di eskombro muskoza",
  "block.minecraft.mossy_cobblestone_stairs": "Eskalero di muskoza eskombro",
  "block.minecraft.mossy_cobblestone_wall": "Muro di eskombro muskoza",
  "block.minecraft.mossy_stone_brick_slab": "Plako di petrabriki muskoza",
  "block.minecraft.mossy_stone_brick_stairs": "Eskalero di petrabriki muskoza",
  "block.minecraft.mossy_stone_brick_wall": "Muro di petrabriki muskoza",
  "block.minecraft.mossy_stone_bricks": "Petrabriki muskoza",
  "block.minecraft.moving_piston": "Pistono movanta",
  "block.minecraft.mud": "Fango",
  "block.minecraft.mud_brick_slab": "Plako di fangobriko",
  "block.minecraft.mud_brick_stairs": "Eskalero di fangobriko",
  "block.minecraft.mud_brick_wall": "Muro di fangobriki",
  "block.minecraft.mud_bricks": "Fangobriki",
  "block.minecraft.muddy_mangrove_roots": "Fangoza radiki mangliera",
  "block.minecraft.mushroom_stem": "Stipito di fungo",
  "block.minecraft.mycelium": "Mycelio",
  "block.minecraft.nether_brick_fence": "Netherbrika fenco",
  "block.minecraft.nether_brick_slab": "Plako di netherbriko",
  "block.minecraft.nether_brick_stairs": "Eskalero di netherbriko",
  "block.minecraft.nether_brick_wall": "Muro di netherbriki",
  "block.minecraft.nether_bricks": "Netherbriki",
  "block.minecraft.nether_gold_ore": "Erco di oro netherala",
  "block.minecraft.nether_portal": "Portalo di Nether",
  "block.minecraft.nether_quartz_ore": "Erco di quarco",
  "block.minecraft.nether_sprouts": "Sprosi di Nether",
  "block.minecraft.nether_wart": "Veruki di Nether",
  "block.minecraft.nether_wart_block": "Bloko di netherveruko",
  "block.minecraft.netherite_block": "Bloko di netherito",
  "block.minecraft.netherrack": "Netherracko",
  "block.minecraft.note_block": "Notbloko",
  "block.minecraft.oak_button": "Butono querka",
  "block.minecraft.oak_door": "Pordo querka",
  "block.minecraft.oak_fence": "Fenco querka",
  "block.minecraft.oak_fence_gate": "Pordeto querka",
  "block.minecraft.oak_hanging_sign": "Pendanta signo querka",
  "block.minecraft.oak_leaves": "Folii querka",
  "block.minecraft.oak_log": "Lenio querka",
  "block.minecraft.oak_planks": "Planki querka",
  "block.minecraft.oak_pressure_plate": "Presoplako querka",
  "block.minecraft.oak_sapling": "Arboreto querka",
  "block.minecraft.oak_shelf": "Querka Planko",
  "block.minecraft.oak_sign": "Signo querka",
  "block.minecraft.oak_slab": "Plako querka",
  "block.minecraft.oak_stairs": "Eskalero querka",
  "block.minecraft.oak_trapdoor": "Trapo querka",
  "block.minecraft.oak_wall_hanging_sign": "Murala pendanta signo querka",
  "block.minecraft.oak_wall_sign": "Murala signo querka",
  "block.minecraft.oak_wood": "Ligno querka",
  "block.minecraft.observer": "Observilo",
  "block.minecraft.obsidian": "Obsidiano",
  "block.minecraft.ochre_froglight": "Okra Froglumo",
  "block.minecraft.ominous_banner": "Banero malaugura",
  "block.minecraft.open_eyeblossom": "Open Eyeblossom",
  "block.minecraft.orange_banner": "Oranjea banero",
  "block.minecraft.orange_bed": "Oranjea lito",
  "block.minecraft.orange_candle": "Oranjea kandelo",
  "block.minecraft.orange_candle_cake": "Kuko kun oranjea kandelo",
  "block.minecraft.orange_carpet": "Oranjea tapiso",
  "block.minecraft.orange_concrete": "Oranjea betono",
  "block.minecraft.orange_concrete_powder": "Oranjea betonpulvero",
  "block.minecraft.orange_glazed_terracotta": "Oranjea terakoto glezita",
  "block.minecraft.orange_shulker_box": "Oranjea buxo di Shulkero",
  "block.minecraft.orange_stained_glass": "Oranjea vitro tintita",
  "block.minecraft.orange_stained_glass_pane": "Oranjea vitrokarelo tintita",
  "block.minecraft.orange_terracotta": "Oranjea terakoto",
  "block.minecraft.orange_tulip": "Oranjea tulipo",
  "block.minecraft.orange_wool": "Oranjea lano",
  "block.minecraft.oxeye_daisy": "Margrito",
  "block.minecraft.oxidized_chiseled_copper": "Oksidita Kizita Kupro",
  "block.minecraft.oxidized_copper": "Kupro oxidizita",
  "block.minecraft.oxidized_copper_bars": "Oxidized Copper Bars",
  "block.minecraft.oxidized_copper_bulb": "Oksidita Kupra Bulbo",
  "block.minecraft.oxidized_copper_chain": "Oxidized Copper Chain",
  "block.minecraft.oxidized_copper_chest": "Oxidized Copper Chest",
  "block.minecraft.oxidized_copper_door": "Oksidita Kupra Pordo",
  "block.minecraft.oxidized_copper_golem_statue": "Oxidized Copper Golem Statue",
  "block.minecraft.oxidized_copper_grate": "Oksidita Kupra Krado",
  "block.minecraft.oxidized_copper_lantern": "Oxidized Copper Lantern",
  "block.minecraft.oxidized_copper_trapdoor": "Oksidita Kupra Kaptraporto",
  "block.minecraft.oxidized_cut_copper": "Kupro oxidizita tailita",
  "block.minecraft.oxidized_cut_copper_slab": "Plako kupra oxidizita tailita",
  "block.minecraft.oxidized_cut_copper_stairs": "Eskalero kupra oxidizita tailita",
  "block.minecraft.oxidized_lightning_rod": "Oxidized Lightning Rod",
  "block.minecraft.packed_ice": "Glacio ferma",
  "block.minecraft.packed_mud": "Fango ferma",
  "block.minecraft.pale_hanging_moss": "Pale Hanging Moss",
  "block.minecraft.pale_moss_block": "Bloko ek Pala Musko",
  "block.minecraft.pale_moss_carpet": "Pale Moss Carpet",
  "block.minecraft.pale_oak_button": "Butono ek Pala Querko",
  "block.minecraft.pale_oak_door": "Pordo ek Pala Querko",
  "block.minecraft.pale_oak_fence": "Querka Fenco",
  "block.minecraft.pale_oak_fence_gate": "Fenco ek Pala Querko",
  "block.minecraft.pale_oak_hanging_sign": "Pale Oak Hanging Sign",
  "block.minecraft.pale_oak_leaves": "Folii ek Pala Querko",
  "block.minecraft.pale_oak_log": "Pale Oak Log",
  "block.minecraft.pale_oak_planks": "Pale Oak Planks",
  "block.minecraft.pale_oak_pressure_plate": "Pale Oak Pressure Plate",
  "block.minecraft.pale_oak_sapling": "Pale Oak Sapling",
  "block.minecraft.pale_oak_shelf": "Pale Oak Shelf",
  "block.minecraft.pale_oak_sign": "Pale Oak Sign",
  "block.minecraft.pale_oak_slab": "Pale Oak Slab",
  "block.minecraft.pale_oak_stairs": "Pale Oak Stairs",
  "block.minecraft.pale_oak_trapdoor": "Pale Oak Trapdoor",
  "block.minecraft.pale_oak_wall_hanging_sign": "Pale Oak Wall Hanging Sign",
  "block.minecraft.pale_oak_wall_sign": "Pale Oak Wall Sign",
  "block.minecraft.pale_oak_wood": "Ligno obskurquerka",
  "block.minecraft.pearlescent_froglight": "Perl-lumina Froglumo",
  "block.minecraft.peony": "Peonio",
  "block.minecraft.petrified_oak_slab": "Petrigita plako querka",
  "block.minecraft.piglin_head": "Kapulkapo",
  "block.minecraft.piglin_wall_head": "Kapomura Kapulkapo",
  "block.minecraft.pink_banner": "Rozea banero",
  "block.minecraft.pink_bed": "Rozea lito",
  "block.minecraft.pink_candle": "Rozea kandelo",
  "block.minecraft.pink_candle_cake": "Kuko kun rozea kandelo",
  "block.minecraft.pink_carpet": "Rozea tapiso",
  "block.minecraft.pink_concrete": "Rozea betono",
  "block.minecraft.pink_concrete_powder": "Rozea betonpulvero",
  "block.minecraft.pink_glazed_terracotta": "Rozea terakoto glezita",
  "block.minecraft.pink_petals": "Pink Petals",
  "block.minecraft.pink_shulker_box": "Rozea buxo di Shulkero",
  "block.minecraft.pink_stained_glass": "Rozea vitro tintita",
  "block.minecraft.pink_stained_glass_pane": "Rozea vitrokarelo tintita",
  "block.minecraft.pink_terracotta": "Rozea terakoto",
  "block.minecraft.pink_tulip": "Rozea tulipo",
  "block.minecraft.pink_wool": "Rozea lano",
  "block.minecraft.piston": "Pistono",
  "block.minecraft.piston_head": "Kapo di pistono",
  "block.minecraft.pitcher_crop": "Kruĉa Kresko",
  "block.minecraft.pitcher_plant": "Kruĉa Planto",
  "block.minecraft.player_head": "Kapo di ludanto",
  "block.minecraft.player_head.named": "Kapo di %s",
  "block.minecraft.player_wall_head": "Murala kapo di ludanto",
  "block.minecraft.podzol": "Podzolo",
  "block.minecraft.pointed_dripstone": "Gutopetro pinta",
  "block.minecraft.polished_andesite": "Polisita andesito",
  "block.minecraft.polished_andesite_slab": "Polisita plako andesita",
  "block.minecraft.polished_andesite_stairs": "Polisita eskalero andesita",
  "block.minecraft.polished_basalt": "Bazalto polisita",
  "block.minecraft.polished_blackstone": "Polisita nigrapetro",
  "block.minecraft.polished_blackstone_brick_slab": "Polisita plako di briko nigrapetra",
  "block.minecraft.polished_blackstone_brick_stairs": "Polisita eskalero di briko nigrapetra",
  "block.minecraft.polished_blackstone_brick_wall": "Polisita muro di briko nigrapetra",
  "block.minecraft.polished_blackstone_bricks": "Polisita briki nigrapetra",
  "block.minecraft.polished_blackstone_button": "Polisita butono nigrapetra",
  "block.minecraft.polished_blackstone_pressure_plate": "Polisita presoplako nigrapetra",
  "block.minecraft.polished_blackstone_slab": "Polisita plako nigrapetra",
  "block.minecraft.polished_blackstone_stairs": "Polisita eskalero nigrapetra",
  "block.minecraft.polished_blackstone_wall": "Muro di polisita nigrapetro",
  "block.minecraft.polished_deepslate": "Polisita profundardezo",
  "block.minecraft.polished_deepslate_slab": "Plako di polisita profundardezo",
  "block.minecraft.polished_deepslate_stairs": "Eskalero di polisita profundardezo",
  "block.minecraft.polished_deepslate_wall": "Muro di polisita profundardezo",
  "block.minecraft.polished_diorite": "Polisita diorito",
  "block.minecraft.polished_diorite_slab": "Polisita plako diorita",
  "block.minecraft.polished_diorite_stairs": "Polisita eskalero diorita",
  "block.minecraft.polished_granite": "Polisita granito",
  "block.minecraft.polished_granite_slab": "Polisita plako granita",
  "block.minecraft.polished_granite_stairs": "Polisita eskalero granita",
  "block.minecraft.polished_tuff": "Polurita Tufa",
  "block.minecraft.polished_tuff_slab": "Polurita Tufa Tego",
  "block.minecraft.polished_tuff_stairs": "Poluritaj Tufaj Ŝtuparoj",
  "block.minecraft.polished_tuff_wall": "Polurita Tufa Muro",
  "block.minecraft.poppy": "Papavero",
  "block.minecraft.potatoes": "Potato",
  "block.minecraft.potted_acacia_sapling": "Aboreto akacia en poto",
  "block.minecraft.potted_allium": "Alliumo en poto",
  "block.minecraft.potted_azalea_bush": "Azaleo en poto",
  "block.minecraft.potted_azure_bluet": "Azura aciano en poto",
  "block.minecraft.potted_bamboo": "Bambuo en poto",
  "block.minecraft.potted_birch_sapling": "Aboreto birka en poto",
  "block.minecraft.potted_blue_orchid": "Blua orkideo en poto",
  "block.minecraft.potted_brown_mushroom": "Bruna Fungo en Poto",
  "block.minecraft.potted_cactus": "Kaktuso en poto",
  "block.minecraft.potted_cherry_sapling": "Enpota Kirsan Branĉeto",
  "block.minecraft.potted_closed_eyeblossom": "Potted Closed Eyeblossom",
  "block.minecraft.potted_cornflower": "Aciano en poto",
  "block.minecraft.potted_crimson_fungus": "Fungo karmezina en poto",
  "block.minecraft.potted_crimson_roots": "Radiki karmezina en poto",
  "block.minecraft.potted_dandelion": "Leondento en poto",
  "block.minecraft.potted_dark_oak_sapling": "Aboreto obskurquerka en poto",
  "block.minecraft.potted_dead_bush": "Mortinta busho en poto",
  "block.minecraft.potted_fern": "Filiko en poto",
  "block.minecraft.potted_flowering_azalea_bush": "Florifanta azaleo en poto",
  "block.minecraft.potted_golden_dandelion": "Potted Golden Dandelion",
  "block.minecraft.potted_jungle_sapling": "Aboreto mahagoniera en poto",
  "block.minecraft.potted_lily_of_the_valley": "Maifloro en poto",
  "block.minecraft.potted_mangrove_propagule": "Propagulo mangliera en poto",
  "block.minecraft.potted_oak_sapling": "Aboreto querka en poto",
  "block.minecraft.potted_open_eyeblossom": "Potted Open Eyeblossom",
  "block.minecraft.potted_orange_tulip": "Oranjea tulipo en poto",
  "block.minecraft.potted_oxeye_daisy": "Margrito en poto",
  "block.minecraft.potted_pale_oak_sapling": "Potted Pale Oak Sapling",
  "block.minecraft.potted_pink_tulip": "Rozea tulipo en poto",
  "block.minecraft.potted_poppy": "Papavero en poto",
  "block.minecraft.potted_red_mushroom": "Reda Fungo en Poto",
  "block.minecraft.potted_red_tulip": "Reda tulipo en poto",
  "block.minecraft.potted_spruce_sapling": "Aboreto abieta en poto",
  "block.minecraft.potted_torchflower": "Enpota Fakelo-floro",
  "block.minecraft.potted_warped_fungus": "Fungo bizara en poto",
  "block.minecraft.potted_warped_roots": "Radiki bizara en poto",
  "block.minecraft.potted_white_tulip": "Blanka tulipo en poto",
  "block.minecraft.potted_wither_rose": "Witherrozo en poto",
  "block.minecraft.powder_snow": "Nivo pulvera",
  "block.minecraft.powder_snow_cauldron": "Kaldrono di nivo pulvera",
  "block.minecraft.powered_rail": "Relo di propulso",
  "block.minecraft.prismarine": "Prismarino",
  "block.minecraft.prismarine_brick_slab": "Plako di briko prismarina",
  "block.minecraft.prismarine_brick_stairs": "Eskalero di briki prismarina",
  "block.minecraft.prismarine_bricks": "Briki di prismarino",
  "block.minecraft.prismarine_slab": "Plako di prismarino",
  "block.minecraft.prismarine_stairs": "Eskalero di prismarino",
  "block.minecraft.prismarine_wall": "Muro di prismarino",
  "block.minecraft.pumpkin": "Kukurbito",
  "block.minecraft.pumpkin_stem": "Stipito di kukurbito",
  "block.minecraft.purple_banner": "Purpura banero",
  "block.minecraft.purple_bed": "Purpura lito",
  "block.minecraft.purple_candle": "Purpura kandelo",
  "block.minecraft.purple_candle_cake": "Kuko kun purpura kandelo",
  "block.minecraft.purple_carpet": "Purpura tapiso",
  "block.minecraft.purple_concrete": "Purpura betono",
  "block.minecraft.purple_concrete_powder": "Purpura betonpulvero",
  "block.minecraft.purple_glazed_terracotta": "Purpura terakoto glezita",
  "block.minecraft.purple_shulker_box": "Purpura buxo di Shulkero",
  "block.minecraft.purple_stained_glass": "Purpura vitro tintita",
  "block.minecraft.purple_stained_glass_pane": "Purpura vitrokarelo tintita",
  "block.minecraft.purple_terracotta": "Purpura terakoto",
  "block.minecraft.purple_wool": "Purpura lano",
  "block.minecraft.purpur_block": "Bloko di purpuro",
  "block.minecraft.purpur_pillar": "Kolono di purpuro",
  "block.minecraft.purpur_slab": "Plako di purpuro",
  "block.minecraft.purpur_stairs": "Eskalero di purpuro",
  "block.minecraft.quartz_block": "Bloko di quarco",
  "block.minecraft.quartz_bricks": "Briki di quarco",
  "block.minecraft.quartz_pillar": "Kolono di quarco",
  "block.minecraft.quartz_slab": "Plako di quarco",
  "block.minecraft.quartz_stairs": "Eskalero di quarco",
  "block.minecraft.rail": "Relo",
  "block.minecraft.raw_copper_block": "Bloko di kruda kupro",
  "block.minecraft.raw_gold_block": "Bloko di kruda oro",
  "block.minecraft.raw_iron_block": "Bloko di kruda fero",
  "block.minecraft.red_banner": "Reda banero",
  "block.minecraft.red_bed": "Reda lito",
  "block.minecraft.red_candle": "Reda kandelo",
  "block.minecraft.red_candle_cake": "Kuko kun reda kandelo",
  "block.minecraft.red_carpet": "Reda tapiso",
  "block.minecraft.red_concrete": "Reda betono",
  "block.minecraft.red_concrete_powder": "Reda betonpulvero",
  "block.minecraft.red_glazed_terracotta": "Reda terakoto glezita",
  "block.minecraft.red_mushroom": "Reda fungo",
  "block.minecraft.red_mushroom_block": "Bloki di fungo reda",
  "block.minecraft.red_nether_brick_slab": "Plako di reda netherbriki",
  "block.minecraft.red_nether_brick_stairs": "Eskalero di reda netherbriki",
  "block.minecraft.red_nether_brick_wall": "Muro di reda netherbriki",
  "block.minecraft.red_nether_bricks": "Reda netherbriki",
  "block.minecraft.red_sand": "Reda sablo",
  "block.minecraft.red_sandstone": "Reda greso",
  "block.minecraft.red_sandstone_slab": "Plako di greso reda",
  "block.minecraft.red_sandstone_stairs": "Eskalero di reda greso",
  "block.minecraft.red_sandstone_wall": "Muro di reda greso",
  "block.minecraft.red_shulker_box": "Reda buxo di Shulkero",
  "block.minecraft.red_stained_glass": "Reda vitro tintita",
  "block.minecraft.red_stained_glass_pane": "Reda vitrokarelo tintita",
  "block.minecraft.red_terracotta": "Reda terakoto",
  "block.minecraft.red_tulip": "Reda tulipo",
  "block.minecraft.red_wool": "Reda lano",
  "block.minecraft.redstone_block": "Bloko di redstoneo",
  "block.minecraft.redstone_lamp": "Lampo di redstoneo",
  "block.minecraft.redstone_ore": "Erco di redstoneo",
  "block.minecraft.redstone_torch": "Torch di redstoneo",
  "block.minecraft.redstone_wall_torch": "Murala torcho di redstoneo",
  "block.minecraft.redstone_wire": "Redstonefilo",
  "block.minecraft.reinforced_deepslate": "Plufortigita profundardezo",
  "block.minecraft.repeater": "Repetilo di redstoneo",
  "block.minecraft.repeating_command_block": "Bloko di komandi iteranta",
  "block.minecraft.resin_block": "Block of Resin",
  "block.minecraft.resin_brick_slab": "Resin Brick Slab",
  "block.minecraft.resin_brick_stairs": "Resin Brick Stairs",
  "block.minecraft.resin_brick_wall": "Resin Brick Wall",
  "block.minecraft.resin_bricks": "Resin Bricks",
  "block.minecraft.resin_clump": "Resin Clump",
  "block.minecraft.respawn_anchor": "Regenitankro",
  "block.minecraft.rooted_dirt": "Sulo radikizita",
  "block.minecraft.rose_bush": "Roziero",
  "block.minecraft.sand": "Sablo",
  "block.minecraft.sandstone": "Greso",
  "block.minecraft.sandstone_slab": "Plako di greso",
  "block.minecraft.sandstone_stairs": "Eskalero di greso",
  "block.minecraft.sandstone_wall": "Muro di greso",
  "block.minecraft.scaffolding": "Eshafodo",
  "block.minecraft.sculk": "Sculko",
  "block.minecraft.sculk_catalyst": "Katalizivo di Sculko",
  "block.minecraft.sculk_sensor": "Detektoro di Sculko",
  "block.minecraft.sculk_shrieker": "Krieganto di Sculko",
  "block.minecraft.sculk_vein": "Veino di Sculko",
  "block.minecraft.sea_lantern": "Marlanterno",
  "block.minecraft.sea_pickle": "Piklo marala",
  "block.minecraft.seagrass": "Marherbo",
  "block.minecraft.set_spawn": "Rigenitar-loko definesis",
  "block.minecraft.short_dry_grass": "Short Dry Grass",
  "block.minecraft.short_grass": "Korta Herbo",
  "block.minecraft.shroomlight": "Fungalumo",
  "block.minecraft.shulker_box": "Buxo di Shulkero",
  "block.minecraft.skeleton_skull": "Kranio di skeleto",
  "block.minecraft.skeleton_wall_skull": "Murala kranio di skeleto",
  "block.minecraft.slime_block": "Bloko di slamo",
  "block.minecraft.small_amethyst_bud": "Mikra burjono ametista",
  "block.minecraft.small_dripleaf": "Gutofolio mikra",
  "block.minecraft.smithing_table": "Tablo di forjisto",
  "block.minecraft.smoker": "Fumizilo",
  "block.minecraft.smooth_basalt": "Bazalto glata",
  "block.minecraft.smooth_quartz": "Bloko di quarco glata",
  "block.minecraft.smooth_quartz_slab": "Plako di quarco glata",
  "block.minecraft.smooth_quartz_stairs": "Eskalero di quarco glata",
  "block.minecraft.smooth_red_sandstone": "Reda greso glata",
  "block.minecraft.smooth_red_sandstone_slab": "Plako di reda greso glata",
  "block.minecraft.smooth_red_sandstone_stairs": "Eskalero di reda greso glata",
  "block.minecraft.smooth_sandstone": "Greso glata",
  "block.minecraft.smooth_sandstone_slab": "Plako di greso glata",
  "block.minecraft.smooth_sandstone_stairs": "Eskalero di greso glata",
  "block.minecraft.smooth_stone": "Petro glata",
  "block.minecraft.smooth_stone_slab": "Plako di petro glata",
  "block.minecraft.sniffer_egg": "Esnifador Ovo",
  "block.minecraft.snow": "Nivo",
  "block.minecraft.snow_block": "Bloko di nivo",
  "block.minecraft.soul_campfire": "Amnokampfairo",
  "block.minecraft.soul_fire": "Anmofairo",
  "block.minecraft.soul_lantern": "Anmolanterno",
  "block.minecraft.soul_sand": "Anmosablo",
  "block.minecraft.soul_soil": "Anmosulo",
  "block.minecraft.soul_torch": "Amnotorcho",
  "block.minecraft.soul_wall_torch": "Murala amnotorcho",
  "block.minecraft.spawn.not_valid": "Vu ne havas hemlito o regenitankro charjita, od ol esis obstruktata",
  "block.minecraft.spawner": "Monstra Kreilo",
  "block.minecraft.spawner.desc1": "Interagi kun Naski-Ovo:",
  "block.minecraft.spawner.desc2": "Agordas Tipon de Besto",
  "block.minecraft.sponge": "Sponjo",
  "block.minecraft.spore_blossom": "Floro sporoza",
  "block.minecraft.spruce_button": "Butono abieta",
  "block.minecraft.spruce_door": "Pordo abieta",
  "block.minecraft.spruce_fence": "Fenco abieta",
  "block.minecraft.spruce_fence_gate": "Pordeto abieta",
  "block.minecraft.spruce_hanging_sign": "Pendanta signo abieta",
  "block.minecraft.spruce_leaves": "Folii abieta",
  "block.minecraft.spruce_log": "Lenio abieta",
  "block.minecraft.spruce_planks": "Planki abieta",
  "block.minecraft.spruce_pressure_plate": "Presoplako abieta",
  "block.minecraft.spruce_sapling": "Arboreto abieta",
  "block.minecraft.spruce_shelf": "Spruce Shelf",
  "block.minecraft.spruce_sign": "Signo abieta",
  "block.minecraft.spruce_slab": "Plako abieta",
  "block.minecraft.spruce_stairs": "Eskalero abieta",
  "block.minecraft.spruce_trapdoor": "Trapo abieta",
  "block.minecraft.spruce_wall_hanging_sign": "Murala pendanta signo abieta",
  "block.minecraft.spruce_wall_sign": "Murala signo abieta",
  "block.minecraft.spruce_wood": "Ligno abieta",
  "block.minecraft.sticky_piston": "Pistono adherema",
  "block.minecraft.stone": "Petro",
  "block.minecraft.stone_brick_slab": "Plako di petrabriko",
  "block.minecraft.stone_brick_stairs": "Eskalero di petrabriko",
  "block.minecraft.stone_brick_wall": "Muro di petrabriki",
  "block.minecraft.stone_bricks": "Petrabriki",
  "block.minecraft.stone_button": "Petra butono",
  "block.minecraft.stone_pressure_plate": "Petra presoplako",
  "block.minecraft.stone_slab": "Plako di petro",
  "block.minecraft.stone_stairs": "Eskalero di petro",
  "block.minecraft.stonecutter": "Petrotaliilo",
  "block.minecraft.stripped_acacia_log": "Lenio akacia sen kortico",
  "block.minecraft.stripped_acacia_wood": "Ligno akacia sen kortico",
  "block.minecraft.stripped_bamboo_block": "Bloko de Senŝelita Bambuo",
  "block.minecraft.stripped_birch_log": "Lenio birka sen kortico",
  "block.minecraft.stripped_birch_wood": "Ligno birka sen kortico",
  "block.minecraft.stripped_cherry_log": "Senpela Ĉeriza Registro",
  "block.minecraft.stripped_cherry_wood": "Senpela Ĉeriza Ligno",
  "block.minecraft.stripped_crimson_hyphae": "Hyfei karmezina sen kortico",
  "block.minecraft.stripped_crimson_stem": "Stipo karmezina sen kortico",
  "block.minecraft.stripped_dark_oak_log": "Lenio obskurquerka sen kortico",
  "block.minecraft.stripped_dark_oak_wood": "Ligno obskurquerka sen kortico",
  "block.minecraft.stripped_jungle_log": "Lenio mahagoniera sen kortico",
  "block.minecraft.stripped_jungle_wood": "Ligno mahagoniera sen kortico",
  "block.minecraft.stripped_mangrove_log": "Lenio mangliera sen kortico",
  "block.minecraft.stripped_mangrove_wood": "Ligno mangliera sen kortico",
  "block.minecraft.stripped_oak_log": "Lenio querka sen kortico",
  "block.minecraft.stripped_oak_wood": "Ligno querka sen kortico",
  "block.minecraft.stripped_pale_oak_log": "Stripped Pale Oak Log",
  "block.minecraft.stripped_pale_oak_wood": "Stripped Pale Oak Wood",
  "block.minecraft.stripped_spruce_log": "Lenio abieta sen kortico",
  "block.minecraft.stripped_spruce_wood": "Ligno abieta sen kortico",
  "block.minecraft.stripped_warped_hyphae": "Hyfei bizara sen kortico",
  "block.minecraft.stripped_warped_stem": "Stipo bizara sen kortico",
  "block.minecraft.structure_block": "Bloko strukturala",
  "block.minecraft.structure_void": "Vakuo strukturala",
  "block.minecraft.sugar_cane": "Sukrokano",
  "block.minecraft.sunflower": "Sunfloro",
  "block.minecraft.suspicious_gravel": "Suspekta Ŝtelo",
  "block.minecraft.suspicious_sand": "Suspekta Sableto",
  "block.minecraft.sweet_berry_bush": "Arbusto di dolcaberi",
  "block.minecraft.tall_dry_grass": "Tall Dry Grass",
  "block.minecraft.tall_grass": "Herbo alta",
  "block.minecraft.tall_seagrass": "Marherbo alta",
  "block.minecraft.target": "Pafskopo",
  "block.minecraft.terracotta": "Terakoto",
  "block.minecraft.test_block": "Test Block",
  "block.minecraft.test_instance_block": "Test Instance Block",
  "block.minecraft.tinted_glass": "Vitro obskurigita",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "TNT explosions are disabled",
  "block.minecraft.torch": "Torcho",
  "block.minecraft.torchflower": "Torĉafloro",
  "block.minecraft.torchflower_crop": "Kultivaĵo de Torĉafloro",
  "block.minecraft.trapped_chest": "Kofro insidiita",
  "block.minecraft.trial_spawner": "Provospawnilo",
  "block.minecraft.tripwire": "Insidia filo",
  "block.minecraft.tripwire_hook": "Hoko di insidia filo",
  "block.minecraft.tube_coral": "Pipeta koralio",
  "block.minecraft.tube_coral_block": "Bloko di pipeta koralio",
  "block.minecraft.tube_coral_fan": "Fano di pipeta koralio",
  "block.minecraft.tube_coral_wall_fan": "Murala fano di pipeta koralio",
  "block.minecraft.tuff": "Tofo",
  "block.minecraft.tuff_brick_slab": "Plato el tufa briko",
  "block.minecraft.tuff_brick_stairs": "Sxtupoj el tufa briko",
  "block.minecraft.tuff_brick_wall": "Murŝtona murejo el tufo",
  "block.minecraft.tuff_bricks": "Murŝtonoj el tufo",
  "block.minecraft.tuff_slab": "Tavolo el tufo",
  "block.minecraft.tuff_stairs": "Ŝtuparo el tufo",
  "block.minecraft.tuff_wall": "Tufta murejo",
  "block.minecraft.turtle_egg": "Ovo di tortugo",
  "block.minecraft.twisting_vines": "Viti tordanta",
  "block.minecraft.twisting_vines_plant": "Planto di viti tordanta",
  "block.minecraft.vault": "Ŝlosilejo",
  "block.minecraft.verdant_froglight": "Verdaj lumbriloj",
  "block.minecraft.vine": "Viti",
  "block.minecraft.void_air": "Aero vakuala",
  "block.minecraft.wall_torch": "Murala torcho",
  "block.minecraft.warped_button": "Butono bizara",
  "block.minecraft.warped_door": "Pordo bizara",
  "block.minecraft.warped_fence": "Fenco bizara",
  "block.minecraft.warped_fence_gate": "Pordeto bizara",
  "block.minecraft.warped_fungus": "Fungo bizara",
  "block.minecraft.warped_hanging_sign": "Pendanta signo bizara",
  "block.minecraft.warped_hyphae": "Hyfei bizara",
  "block.minecraft.warped_nylium": "Nylio bizara",
  "block.minecraft.warped_planks": "Planki bizara",
  "block.minecraft.warped_pressure_plate": "Presoplako bizara",
  "block.minecraft.warped_roots": "Radiki bizara",
  "block.minecraft.warped_shelf": "Warped Shelf",
  "block.minecraft.warped_sign": "Signo bizara",
  "block.minecraft.warped_slab": "Plako bizara",
  "block.minecraft.warped_stairs": "Eskalero bizara",
  "block.minecraft.warped_stem": "Stipo bizara",
  "block.minecraft.warped_trapdoor": "Trapo bizara",
  "block.minecraft.warped_wall_hanging_sign": "Murala pendanta signo bizara",
  "block.minecraft.warped_wall_sign": "Murala signo bizara",
  "block.minecraft.warped_wart_block": "Bloko di veruko bizara",
  "block.minecraft.water": "Aquo",
  "block.minecraft.water_cauldron": "Kaldrono di aquo",
  "block.minecraft.waxed_chiseled_copper": "Vaksita skulptita kupro",
  "block.minecraft.waxed_copper_bars": "Waxed Copper Bars",
  "block.minecraft.waxed_copper_block": "Vaxizita bloko di kupro",
  "block.minecraft.waxed_copper_bulb": "Vaksita kupra bulbo",
  "block.minecraft.waxed_copper_chain": "Waxed Copper Chain",
  "block.minecraft.waxed_copper_chest": "Waxed Copper Chest",
  "block.minecraft.waxed_copper_door": "Pordo el vaksita kupro",
  "block.minecraft.waxed_copper_golem_statue": "Waxed Copper Golem Statue",
  "block.minecraft.waxed_copper_grate": "Vaksita kupra grato",
  "block.minecraft.waxed_copper_lantern": "Waxed Copper Lantern",
  "block.minecraft.waxed_copper_trapdoor": "Kupra pordtruo elvaksa",
  "block.minecraft.waxed_cut_copper": "Vaxizita kupro tailita",
  "block.minecraft.waxed_cut_copper_slab": "Vaxizita plako kupra tailita",
  "block.minecraft.waxed_cut_copper_stairs": "Vaxizita eskalero kupra tailita",
  "block.minecraft.waxed_exposed_chiseled_copper": "Vaksita ekstera skulptita kupro",
  "block.minecraft.waxed_exposed_copper": "Vaxizita kupro expozita",
  "block.minecraft.waxed_exposed_copper_bars": "Waxed Exposed Copper Bars",
  "block.minecraft.waxed_exposed_copper_bulb": "Vaksita ekstera kupra bulbo",
  "block.minecraft.waxed_exposed_copper_chain": "Waxed Exposed Copper Chain",
  "block.minecraft.waxed_exposed_copper_chest": "Waxed Exposed Copper Chest",
  "block.minecraft.waxed_exposed_copper_door": "Vaksita ekstera kupra pordo",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Waxed Exposed Copper Golem Statue",
  "block.minecraft.waxed_exposed_copper_grate": "Vaksita ekstera kupra grato",
  "block.minecraft.waxed_exposed_copper_lantern": "Waxed Exposed Copper Lantern",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Vaksita ekstera kupra pordtruo",
  "block.minecraft.waxed_exposed_cut_copper": "Vaxizita kupro expozita tailita",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Vaxizita plako kupra expozita tailita",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Vaxizita eskalero kupra expozita tailita",
  "block.minecraft.waxed_exposed_lightning_rod": "Waxed Exposed Lightning Rod",
  "block.minecraft.waxed_lightning_rod": "Waxed Lightning Rod",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Vaksita oksidiĝinta skulptita kupro",
  "block.minecraft.waxed_oxidized_copper": "Vaxizita kupro oxidizita",
  "block.minecraft.waxed_oxidized_copper_bars": "Waxed Oxidized Copper Bars",
  "block.minecraft.waxed_oxidized_copper_bulb": "Vaksita oksidiĝinta kupra bulbo",
  "block.minecraft.waxed_oxidized_copper_chain": "Waxed Oxidized Copper Chain",
  "block.minecraft.waxed_oxidized_copper_chest": "Waxed Oxidized Copper Chest",
  "block.minecraft.waxed_oxidized_copper_door": "Vaksita oksidiĝinta kupra pordo",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Waxed Oxidized Copper Golem Statue",
  "block.minecraft.waxed_oxidized_copper_grate": "Vaksita oksidiĝinta kupra grato",
  "block.minecraft.waxed_oxidized_copper_lantern": "Waxed Oxidized Copper Lantern",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Vaksita oksidiĝinta kupra pordtruo",
  "block.minecraft.waxed_oxidized_cut_copper": "Vaxizita kupro oxidizita tailita",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Vaxizita plako kupra oxidizita tailita",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Vaxizita eskalero kupra oxidizita tailita",
  "block.minecraft.waxed_oxidized_lightning_rod": "Waxed Oxidized Lightning Rod",
  "block.minecraft.waxed_weathered_chiseled_copper": "Vaksita veterita skulptita kupro",
  "block.minecraft.waxed_weathered_copper": "Vaxizita kupro frusta",
  "block.minecraft.waxed_weathered_copper_bars": "Waxed Weathered Copper Bars",
  "block.minecraft.waxed_weathered_copper_bulb": "Vaksita veterita kupra bulbo",
  "block.minecraft.waxed_weathered_copper_chain": "Waxed Weathered Copper Chain",
  "block.minecraft.waxed_weathered_copper_chest": "Waxed Weathered Copper Chest",
  "block.minecraft.waxed_weathered_copper_door": "Vaksita veterita kupra pordo",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Waxed Weathered Copper Golem Statue",
  "block.minecraft.waxed_weathered_copper_grate": "Vaksita veterita kupra grato",
  "block.minecraft.waxed_weathered_copper_lantern": "Waxed Weathered Copper Lantern",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Vaksita veterita kupra pordtruo",
  "block.minecraft.waxed_weathered_cut_copper": "Vaxizita kupro frusta tailita",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Vaxizita plako kupra frusta tailita",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Vaxizita eskalero kupra frusta tailita",
  "block.minecraft.waxed_weathered_lightning_rod": "Waxed Weathered Lightning Rod",
  "block.minecraft.weathered_chiseled_copper": "Veterita skulptita kupro",
  "block.minecraft.weathered_copper": "Kupro frusta",
  "block.minecraft.weathered_copper_bars": "Weathered Copper Bars",
  "block.minecraft.weathered_copper_bulb": "Veterita kupra bulbo",
  "block.minecraft.weathered_copper_chain": "Weathered Copper Chain",
  "block.minecraft.weathered_copper_chest": "Weathered Copper Chest",
  "block.minecraft.weathered_copper_door": "Veterita kupra pordo",
  "block.minecraft.weathered_copper_golem_statue": "Weathered Copper Golem Statue",
  "block.minecraft.weathered_copper_grate": "Veterita kupra grato",
  "block.minecraft.weathered_copper_lantern": "Weathered Copper Lantern",
  "block.minecraft.weathered_copper_trapdoor": "Veterita kupra pordtruo",
  "block.minecraft.weathered_cut_copper": "Kupro frusta tailita",
  "block.minecraft.weathered_cut_copper_slab": "Plako kupra frusta tailita",
  "block.minecraft.weathered_cut_copper_stairs": "Eskalero kupra frusta tailita",
  "block.minecraft.weathered_lightning_rod": "Weathered Lightning Rod",
  "block.minecraft.weeping_vines": "Viti ploranta",
  "block.minecraft.weeping_vines_plant": "Planto di viti ploranta",
  "block.minecraft.wet_sponge": "Sponjo imbibita",
  "block.minecraft.wheat": "Rekoltajo di frumento",
  "block.minecraft.white_banner": "Blanka banero",
  "block.minecraft.white_bed": "Blanka lito",
  "block.minecraft.white_candle": "Blanka kandelo",
  "block.minecraft.white_candle_cake": "Kuko kun blanka kandelo",
  "block.minecraft.white_carpet": "Blanka tapiso",
  "block.minecraft.white_concrete": "Blanka betono",
  "block.minecraft.white_concrete_powder": "Blanka betonpulvero",
  "block.minecraft.white_glazed_terracotta": "Blanka terakoto glezita",
  "block.minecraft.white_shulker_box": "Blanka buxo di Shulkero",
  "block.minecraft.white_stained_glass": "Blanka vitro tintita",
  "block.minecraft.white_stained_glass_pane": "Blanka vitrokarelo tintita",
  "block.minecraft.white_terracotta": "Blanka terakoto",
  "block.minecraft.white_tulip": "Blanka tulipo",
  "block.minecraft.white_wool": "Blanka lano",
  "block.minecraft.wildflowers": "Wildflowers",
  "block.minecraft.wither_rose": "Witherrozo",
  "block.minecraft.wither_skeleton_skull": "Kranio di witherskeleto",
  "block.minecraft.wither_skeleton_wall_skull": "Murala kranio di witherskeleto",
  "block.minecraft.yellow_banner": "Flava banero",
  "block.minecraft.yellow_bed": "Flava lito",
  "block.minecraft.yellow_candle": "Flava kandelo",
  "block.minecraft.yellow_candle_cake": "Kuko kun flava kandelo",
  "block.minecraft.yellow_carpet": "Flava tapiso",
  "block.minecraft.yellow_concrete": "Flava betono",
  "block.minecraft.yellow_concrete_powder": "Flava betonpulvero",
  "block.minecraft.yellow_glazed_terracotta": "Flava terakoto glezita",
  "block.minecraft.yellow_shulker_box": "Flava buxo di Shulkero",
  "block.minecraft.yellow_stained_glass": "Flava vitro tintita",
  "block.minecraft.yellow_stained_glass_pane": "Flava vitrokarelo tintita",
  "block.minecraft.yellow_terracotta": "Flava terakoto",
  "block.minecraft.yellow_wool": "Flava lano",
  "block.minecraft.zombie_head": "Kapo di zombio",
  "block.minecraft.zombie_wall_head": "Murala kapo di zombio",
  "item.minecraft.acacia_boat": "Batelo akacia",
  "item.minecraft.acacia_chest_boat": "Batelo akacia kun kofro",
  "item.minecraft.allay_spawn_egg": "Kreurovo di alejo",
  "item.minecraft.amethyst_shard": "Ruptopeco ametista",
  "item.minecraft.angler_pottery_shard": "Fiŝkaptista Argilpeco",
  "item.minecraft.angler_pottery_sherd": "Fiŝkaptista Argilpeco",
  "item.minecraft.apple": "Pomo",
  "item.minecraft.archer_pottery_shard": "Sago Argilpeco",
  "item.minecraft.archer_pottery_sherd": "Sago Argilpeco",
  "item.minecraft.armadillo_scute": "Armdilo Skarpo",
  "item.minecraft.armadillo_spawn_egg": "Armdilo Kovi Ovo",
  "item.minecraft.armor_stand": "Vestiero",
  "item.minecraft.arms_up_pottery_shard": "Brakumi Argilpeco",
  "item.minecraft.arms_up_pottery_sherd": "Brakumi Argilpeco",
  "item.minecraft.arrow": "Flecho",
  "item.minecraft.axolotl_bucket": "Sitelo di axoloto",
  "item.minecraft.axolotl_spawn_egg": "Kreurovo di axoloto",
  "item.minecraft.baked_potato": "Potato bakita",
  "item.minecraft.bamboo_chest_raft": "Rafto bambua kun kofro",
  "item.minecraft.bamboo_raft": "Rafto bambua",
  "item.minecraft.bat_spawn_egg": "Kreurovo di vespertilio",
  "item.minecraft.bee_spawn_egg": "Frayifanto-ovo di abelo",
  "item.minecraft.beef": "Kruda bovokarno",
  "item.minecraft.beetroot": "Betravo",
  "item.minecraft.beetroot_seeds": "Semini di betravo",
  "item.minecraft.beetroot_soup": "Betravoraguto",
  "item.minecraft.birch_boat": "Batelo birka",
  "item.minecraft.birch_chest_boat": "Batelo birka kun kofro",
  "item.minecraft.black_bundle": "Black Bundle",
  "item.minecraft.black_dye": "Nigra tinto",
  "item.minecraft.black_harness": "Black Harness",
  "item.minecraft.blade_pottery_shard": "Klinga Argilpeco",
  "item.minecraft.blade_pottery_sherd": "Klinga Argilpeco",
  "item.minecraft.blaze_powder": "Pulvero di blazo",
  "item.minecraft.blaze_rod": "Bastono di blazo",
  "item.minecraft.blaze_spawn_egg": "Kreurovo di blazo",
  "item.minecraft.blue_bundle": "Blue Bundle",
  "item.minecraft.blue_dye": "Blua tinto",
  "item.minecraft.blue_egg": "Blua Ovo",
  "item.minecraft.blue_harness": "Blue Harness",
  "item.minecraft.bogged_spawn_egg": "Bogged Spawn Egg",
  "item.minecraft.bolt_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Bolt Armor Trim",
  "item.minecraft.bone": "Osto",
  "item.minecraft.bone_meal": "Polvo di osto",
  "item.minecraft.book": "Libro",
  "item.minecraft.bordure_indented_banner_pattern": "Bordure Indented Banner Pattern",
  "item.minecraft.bow": "Arkarmo",
  "item.minecraft.bowl": "Bolo",
  "item.minecraft.bread": "Pano",
  "item.minecraft.breeze_rod": "Brizo Bastono",
  "item.minecraft.breeze_spawn_egg": "Brizo Naski Ovo",
  "item.minecraft.brewer_pottery_shard": "Bieranto Argilpeco",
  "item.minecraft.brewer_pottery_sherd": "Bieranto Argilpeco",
  "item.minecraft.brewing_stand": "Brasostativo",
  "item.minecraft.brick": "Briko",
  "item.minecraft.brown_bundle": "Brown Bundle",
  "item.minecraft.brown_dye": "Bruna tinto",
  "item.minecraft.brown_egg": "Bruna Ovo",
  "item.minecraft.brown_harness": "Brown Harness",
  "item.minecraft.brush": "Pento",
  "item.minecraft.bucket": "Sitelo",
  "item.minecraft.bundle": "Fasko",
  "item.minecraft.bundle.empty": "Vakua",
  "item.minecraft.bundle.empty.description": "Can hold a mixed stack of items",
  "item.minecraft.bundle.full": "Plena",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Brulanta Argilpeco",
  "item.minecraft.burn_pottery_sherd": "Brulanta Argilpeco",
  "item.minecraft.camel_husk_spawn_egg": "Camel Husk Spawn Egg",
  "item.minecraft.camel_spawn_egg": "Kreurovo di kamelo",
  "item.minecraft.carrot": "Karoto",
  "item.minecraft.carrot_on_a_stick": "Karoto sur bastono",
  "item.minecraft.cat_spawn_egg": "Kreurovo di kato",
  "item.minecraft.cauldron": "Kaldrono",
  "item.minecraft.cave_spider_spawn_egg": "Kreurovo di kavernaraneo",
  "item.minecraft.chainmail_boots": "Boti mashkuta",
  "item.minecraft.chainmail_chestplate": "Torsokuraso mashkuta",
  "item.minecraft.chainmail_helmet": "Helmo mashkuta",
  "item.minecraft.chainmail_leggings": "Pantaloni mashkuta",
  "item.minecraft.charcoal": "Lignakarbono",
  "item.minecraft.cherry_boat": "Ĉeriza Boato",
  "item.minecraft.cherry_chest_boat": "Ĉeriza Boato kun Kofro",
  "item.minecraft.chest_minecart": "Minvagono kun kofro",
  "item.minecraft.chicken": "Kruda hanokarno",
  "item.minecraft.chicken_spawn_egg": "Kreurovo di hano",
  "item.minecraft.chorus_fruit": "Chorusfrukto",
  "item.minecraft.clay_ball": "Argilbulo",
  "item.minecraft.clock": "Horlojo",
  "item.minecraft.coal": "Karbono",
  "item.minecraft.coast_armor_trim_smithing_template": "Forĝarto Matrico",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Coast Armor Trim",
  "item.minecraft.cocoa_beans": "Kakafabi",
  "item.minecraft.cod": "Kruda gado",
  "item.minecraft.cod_bucket": "Sitelo di gado",
  "item.minecraft.cod_spawn_egg": "Kreurovo di gado",
  "item.minecraft.command_block_minecart": "Minvagono kun bloko di komandi",
  "item.minecraft.compass": "Busolo",
  "item.minecraft.cooked_beef": "Bifsteko",
  "item.minecraft.cooked_chicken": "Koquita hanokarno",
  "item.minecraft.cooked_cod": "Koquita gado",
  "item.minecraft.cooked_mutton": "Koquita mutonkarno",
  "item.minecraft.cooked_porkchop": "Koquita porkokarno",
  "item.minecraft.cooked_rabbit": "Koquita kuniklokarno",
  "item.minecraft.cooked_salmon": "Koquita salmono",
  "item.minecraft.cookie": "Bisquito",
  "item.minecraft.copper_axe": "Copper Axe",
  "item.minecraft.copper_boots": "Copper Boots",
  "item.minecraft.copper_chestplate": "Copper Chestplate",
  "item.minecraft.copper_golem_spawn_egg": "Copper Golem Spawn Egg",
  "item.minecraft.copper_helmet": "Copper Helmet",
  "item.minecraft.copper_hoe": "Copper Hoe",
  "item.minecraft.copper_horse_armor": "Copper Horse Armor",
  "item.minecraft.copper_ingot": "Lingoto kupra",
  "item.minecraft.copper_leggings": "Copper Leggings",
  "item.minecraft.copper_nautilus_armor": "Copper Nautilus Armor",
  "item.minecraft.copper_nugget": "Copper Nugget",
  "item.minecraft.copper_pickaxe": "Copper Pickaxe",
  "item.minecraft.copper_shovel": "Copper Shovel",
  "item.minecraft.copper_spear": "Copper Spear",
  "item.minecraft.copper_sword": "Copper Sword",
  "item.minecraft.cow_spawn_egg": "Kreurovo di bovo",
  "item.minecraft.creaking_spawn_egg": "Creaking Spawn Egg",
  "item.minecraft.creeper_banner_pattern": "Shablono di banero",
  "item.minecraft.creeper_banner_pattern.desc": "Creeperfacio",
  "item.minecraft.creeper_banner_pattern.new": "Creeper Charge Banner Pattern",
  "item.minecraft.creeper_spawn_egg": "Kreurovo di creepero",
  "item.minecraft.crossbow": "Arbalesto",
  "item.minecraft.crossbow.projectile": "Projektilo:",
  "item.minecraft.crossbow.projectile.multiple": "Projectile: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Projectile: %s",
  "item.minecraft.cyan_bundle": "Cyan Bundle",
  "item.minecraft.cyan_dye": "Cyana tinto",
  "item.minecraft.cyan_harness": "Cyan Harness",
  "item.minecraft.danger_pottery_shard": "Danĝera Argilpeco",
  "item.minecraft.danger_pottery_sherd": "Danĝera Argilpeco",
  "item.minecraft.dark_oak_boat": "Batelo obskurquerka",
  "item.minecraft.dark_oak_chest_boat": "Batelo obskurquerka kun kofro",
  "item.minecraft.debug_stick": "Bastono di debugar",
  "item.minecraft.debug_stick.empty": "%s ne havas propaji",
  "item.minecraft.debug_stick.select": "selektis \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" a %s",
  "item.minecraft.diamond": "Diamanto",
  "item.minecraft.diamond_axe": "Hakilo diamanta",
  "item.minecraft.diamond_boots": "Boti diamanta",
  "item.minecraft.diamond_chestplate": "Torokuraso diamanta",
  "item.minecraft.diamond_helmet": "Helmo diamanta",
  "item.minecraft.diamond_hoe": "Bineto diamanta",
  "item.minecraft.diamond_horse_armor": "Kavalkuraso diamanta",
  "item.minecraft.diamond_leggings": "Pantaloni diamanta",
  "item.minecraft.diamond_nautilus_armor": "Diamond Nautilus Armor",
  "item.minecraft.diamond_pickaxe": "Piocho diamanta",
  "item.minecraft.diamond_shovel": "Shovelo diamanta",
  "item.minecraft.diamond_spear": "Diamond Spear",
  "item.minecraft.diamond_sword": "Espado diamanta",
  "item.minecraft.disc_fragment_5": "Fragmento diska",
  "item.minecraft.disc_fragment_5.desc": "Muzikdisko - 5",
  "item.minecraft.dolphin_spawn_egg": "Kreurovo di delfino",
  "item.minecraft.donkey_spawn_egg": "Kreurovo di asno",
  "item.minecraft.dragon_breath": "Respirado di drako",
  "item.minecraft.dried_kelp": "Kelpo sikigita",
  "item.minecraft.drowned_spawn_egg": "Kreurovo di dronito",
  "item.minecraft.dune_armor_trim_smithing_template": "Forĝarto Matrico",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Dune Armor Trim",
  "item.minecraft.echo_shard": "Eĥa Argilpeco",
  "item.minecraft.egg": "Ovo",
  "item.minecraft.elder_guardian_spawn_egg": "Kreurovo di seniora guardero",
  "item.minecraft.elytra": "Elitri",
  "item.minecraft.emerald": "Smeraldo",
  "item.minecraft.enchanted_book": "Libro sorcita",
  "item.minecraft.enchanted_golden_apple": "Sorcita pomo ora",
  "item.minecraft.end_crystal": "Kristalo di End",
  "item.minecraft.ender_dragon_spawn_egg": "Ender Drako Naski Ovo",
  "item.minecraft.ender_eye": "Enderokulo",
  "item.minecraft.ender_pearl": "Enderperlo",
  "item.minecraft.enderman_spawn_egg": "Kreurovo di endermano",
  "item.minecraft.endermite_spawn_egg": "Kreurovo di endermito",
  "item.minecraft.evoker_spawn_egg": "Kreurovo di evokanto",
  "item.minecraft.experience_bottle": "Botelo di sorco",
  "item.minecraft.explorer_pottery_shard": "Esploranto Argilpeco",
  "item.minecraft.explorer_pottery_sherd": "Esploranto Argilpeco",
  "item.minecraft.eye_armor_trim_smithing_template": "Modelo di forĝarto",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Eye Armor Trim",
  "item.minecraft.feather": "Plumo",
  "item.minecraft.fermented_spider_eye": "Okulo di araneo fermentacita",
  "item.minecraft.field_masoned_banner_pattern": "Field Masoned Banner Pattern",
  "item.minecraft.filled_map": "Mapo",
  "item.minecraft.fire_charge": "Fairbulo",
  "item.minecraft.firework_rocket": "Fuzeo di pirotekno",
  "item.minecraft.firework_rocket.flight": "Duro di flugo:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Stelo di pirotekno",
  "item.minecraft.firework_star.black": "Nigra",
  "item.minecraft.firework_star.blue": "Blua",
  "item.minecraft.firework_star.brown": "Bruna",
  "item.minecraft.firework_star.custom_color": "Individuala",
  "item.minecraft.firework_star.cyan": "Cyana",
  "item.minecraft.firework_star.fade_to": "Velkar ad",
  "item.minecraft.firework_star.flicker": "Cintilo",
  "item.minecraft.firework_star.gray": "Griza",
  "item.minecraft.firework_star.green": "Verda",
  "item.minecraft.firework_star.light_blue": "Cielblua",
  "item.minecraft.firework_star.light_gray": "Klaragriza",
  "item.minecraft.firework_star.lime": "Klarverda",
  "item.minecraft.firework_star.magenta": "Magenta",
  "item.minecraft.firework_star.orange": "Oranjea",
  "item.minecraft.firework_star.pink": "Rozea",
  "item.minecraft.firework_star.purple": "Purpura",
  "item.minecraft.firework_star.red": "Reda",
  "item.minecraft.firework_star.shape": "Formo nesavata",
  "item.minecraft.firework_star.shape.burst": "Erupto",
  "item.minecraft.firework_star.shape.creeper": "Creeperformo",
  "item.minecraft.firework_star.shape.large_ball": "Globego",
  "item.minecraft.firework_star.shape.small_ball": "Globeto",
  "item.minecraft.firework_star.shape.star": "Stelformo",
  "item.minecraft.firework_star.trail": "Traco",
  "item.minecraft.firework_star.white": "Blanka",
  "item.minecraft.firework_star.yellow": "Flava",
  "item.minecraft.fishing_rod": "Peskobastono",
  "item.minecraft.flint": "Silexo",
  "item.minecraft.flint_and_steel": "Silexo e stalo",
  "item.minecraft.flow_armor_trim_smithing_template": "Forĝista ŝablono",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Flow Armor Trim",
  "item.minecraft.flow_banner_pattern": "Standarda bendero",
  "item.minecraft.flow_banner_pattern.desc": "Fluo",
  "item.minecraft.flow_banner_pattern.new": "Flow Banner Pattern",
  "item.minecraft.flow_pottery_sherd": "Flow Pottery Sherd",
  "item.minecraft.flower_banner_pattern": "Standarda desegno",
  "item.minecraft.flower_banner_pattern.desc": "Floro",
  "item.minecraft.flower_banner_pattern.new": "Flower Charge Banner Pattern",
  "item.minecraft.flower_pot": "Flora vazo",
  "item.minecraft.fox_spawn_egg": "Kreurovo di foxo",
  "item.minecraft.friend_pottery_shard": "Amika argilo ŝerco",
  "item.minecraft.friend_pottery_sherd": "Amika argila ŝerco",
  "item.minecraft.frog_spawn_egg": "Kreurovo di rano",
  "item.minecraft.furnace_minecart": "Minvagono kun furnazo",
  "item.minecraft.ghast_spawn_egg": "Kreurovo di ghasto",
  "item.minecraft.ghast_tear": "Lakrimo di ghasto",
  "item.minecraft.glass_bottle": "Vitra botelo",
  "item.minecraft.glistering_melon_slice": "Loncho di melono brilanta",
  "item.minecraft.globe_banner_pattern": "Standarda desegno",
  "item.minecraft.globe_banner_pattern.desc": "Terkubo",
  "item.minecraft.globe_banner_pattern.new": "Globe Banner Pattern",
  "item.minecraft.glow_berries": "Lumbero",
  "item.minecraft.glow_ink_sac": "Inksako lumanta",
  "item.minecraft.glow_item_frame": "Kadro lumanta",
  "item.minecraft.glow_squid_spawn_egg": "Kreurovo di lumkalmaro",
  "item.minecraft.glowstone_dust": "Lumpetra polvo",
  "item.minecraft.goat_horn": "Kapro korno",
  "item.minecraft.goat_spawn_egg": "Kreurovo di kapro",
  "item.minecraft.gold_ingot": "Lingoto ora",
  "item.minecraft.gold_nugget": "Pepito ora",
  "item.minecraft.golden_apple": "Pomo ora",
  "item.minecraft.golden_axe": "Hakilo ora",
  "item.minecraft.golden_boots": "Boti ora",
  "item.minecraft.golden_carrot": "Karoto ora",
  "item.minecraft.golden_chestplate": "Torokuraso ora",
  "item.minecraft.golden_helmet": "Helmo ora",
  "item.minecraft.golden_hoe": "Bineto ora",
  "item.minecraft.golden_horse_armor": "Kavalkuraso ora",
  "item.minecraft.golden_leggings": "Pantaloni ora",
  "item.minecraft.golden_nautilus_armor": "Golden Nautilus Armor",
  "item.minecraft.golden_pickaxe": "Piocho ora",
  "item.minecraft.golden_shovel": "Shovelo ora",
  "item.minecraft.golden_spear": "Golden Spear",
  "item.minecraft.golden_sword": "Espado ora",
  "item.minecraft.gray_bundle": "Gray Bundle",
  "item.minecraft.gray_dye": "Griza tinto",
  "item.minecraft.gray_harness": "Gray Harness",
  "item.minecraft.green_bundle": "Green Bundle",
  "item.minecraft.green_dye": "Verda tinto",
  "item.minecraft.green_harness": "Green Harness",
  "item.minecraft.guardian_spawn_egg": "Kreurovo di guardero",
  "item.minecraft.gunpowder": "Kanonpulvero",
  "item.minecraft.guster_banner_pattern": "Banner Pattern",
  "item.minecraft.guster_banner_pattern.desc": "Virvolto",
  "item.minecraft.guster_banner_pattern.new": "Guster Banner Pattern",
  "item.minecraft.guster_pottery_sherd": "Guster Pottery Sherd",
  "item.minecraft.happy_ghast_spawn_egg": "Happy Ghast Spawn Egg",
  "item.minecraft.harness": "Harness",
  "item.minecraft.heart_of_the_sea": "Kordio di la maro",
  "item.minecraft.heart_pottery_shard": "Fragmento de argila koro",
  "item.minecraft.heart_pottery_sherd": "Fragmento de argila koro",
  "item.minecraft.heartbreak_pottery_shard": "Fragmento de disrompita argila koro",
  "item.minecraft.heartbreak_pottery_sherd": "Fragmento de disrompita argila kero",
  "item.minecraft.hoglin_spawn_egg": "Kreurovo di hoglino",
  "item.minecraft.honey_bottle": "Botelo di mielo",
  "item.minecraft.honeycomb": "Vabo",
  "item.minecraft.hopper_minecart": "Minvagono kun funelego",
  "item.minecraft.horse_spawn_egg": "Kreurovo di kavalo",
  "item.minecraft.host_armor_trim_smithing_template": "Forĝa modelo",
  "item.minecraft.host_armor_trim_smithing_template.new": "Host Armor Trim",
  "item.minecraft.howl_pottery_shard": "Sherdo di argilo di kriado",
  "item.minecraft.howl_pottery_sherd": "Sherdo di argilo di kriado",
  "item.minecraft.husk_spawn_egg": "Kreurovo di husko",
  "item.minecraft.ink_sac": "Inksako",
  "item.minecraft.iron_axe": "Hakilo fera",
  "item.minecraft.iron_boots": "Boti fera",
  "item.minecraft.iron_chestplate": "Torokuraso fera",
  "item.minecraft.iron_golem_spawn_egg": "Ovo di aparado di fero",
  "item.minecraft.iron_helmet": "Helmo fera",
  "item.minecraft.iron_hoe": "Bineto fera",
  "item.minecraft.iron_horse_armor": "Kavalkuraso fera",
  "item.minecraft.iron_ingot": "Lingoto fera",
  "item.minecraft.iron_leggings": "Pantaloni fera",
  "item.minecraft.iron_nautilus_armor": "Iron Nautilus Armor",
  "item.minecraft.iron_nugget": "Pepiro fera",
  "item.minecraft.iron_pickaxe": "Piocho fera",
  "item.minecraft.iron_shovel": "Shovelo fera",
  "item.minecraft.iron_spear": "Iron Spear",
  "item.minecraft.iron_sword": "Espado fera",
  "item.minecraft.item_frame": "Kadro",
  "item.minecraft.jungle_boat": "Batelo mahagoniera",
  "item.minecraft.jungle_chest_boat": "Batelo mahagoniera kun kofro",
  "item.minecraft.knowledge_book": "Enciklopedio",
  "item.minecraft.lapis_lazuli": "Lapislazulo",
  "item.minecraft.lava_bucket": "Sitelo di Lavao",
  "item.minecraft.lead": "Lazo",
  "item.minecraft.leather": "Ledro",
  "item.minecraft.leather_boots": "Boti ledra",
  "item.minecraft.leather_chestplate": "Tuniko ledra",
  "item.minecraft.leather_helmet": "Boneto ledra",
  "item.minecraft.leather_horse_armor": "Kavalkuraso ledra",
  "item.minecraft.leather_leggings": "Pantaloni ledra",
  "item.minecraft.light_blue_bundle": "Light Blue Bundle",
  "item.minecraft.light_blue_dye": "Cielblua tinto",
  "item.minecraft.light_blue_harness": "Light Blue Harness",
  "item.minecraft.light_gray_bundle": "Light Gray Bundle",
  "item.minecraft.light_gray_dye": "Klargriza tinto",
  "item.minecraft.light_gray_harness": "Light Gray Harness",
  "item.minecraft.lime_bundle": "Lime Bundle",
  "item.minecraft.lime_dye": "Klarverda tinto",
  "item.minecraft.lime_harness": "Lime Harness",
  "item.minecraft.lingering_potion": "Duranta pociono",
  "item.minecraft.lingering_potion.effect.awkward": "Duranta pociono stranja",
  "item.minecraft.lingering_potion.effect.empty": "Duranta pociono nefabrikebla",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Duranta pociono di fairorezisto",
  "item.minecraft.lingering_potion.effect.harming": "Duranta pociono di domajo",
  "item.minecraft.lingering_potion.effect.healing": "Duranta pociono di remedio",
  "item.minecraft.lingering_potion.effect.infested": "Lingering Potion of Infestation",
  "item.minecraft.lingering_potion.effect.invisibility": "Duranta pociono di nevidebleso",
  "item.minecraft.lingering_potion.effect.leaping": "Duranta pociono di saltego",
  "item.minecraft.lingering_potion.effect.levitation": "Duranta pociono di flugeteso",
  "item.minecraft.lingering_potion.effect.luck": "Duranta pociono di chanco",
  "item.minecraft.lingering_potion.effect.mundane": "Duranta pociono ordinara",
  "item.minecraft.lingering_potion.effect.night_vision": "Duranta pociono di noktvidado",
  "item.minecraft.lingering_potion.effect.oozing": "Lingering Potion of Oozing",
  "item.minecraft.lingering_potion.effect.poison": "Duranta pociono di toxiko",
  "item.minecraft.lingering_potion.effect.regeneration": "Duranta pociono di regenereso",
  "item.minecraft.lingering_potion.effect.slow_falling": "Duranta pociono di lenta faligo",
  "item.minecraft.lingering_potion.effect.slowness": "Duranta pociono di lenteso",
  "item.minecraft.lingering_potion.effect.strength": "Duranta pociono di forteso",
  "item.minecraft.lingering_potion.effect.swiftness": "Duranta pociono di rapideso",
  "item.minecraft.lingering_potion.effect.thick": "Duranta pociono densa",
  "item.minecraft.lingering_potion.effect.turtle_master": "Duranta pociono di la tortugomastro",
  "item.minecraft.lingering_potion.effect.water": "Duranta aquobotelo",
  "item.minecraft.lingering_potion.effect.water_breathing": "Duranta pociono di aquarespiro",
  "item.minecraft.lingering_potion.effect.weakness": "Duranta pociono di febleso",
  "item.minecraft.lingering_potion.effect.weaving": "Lingering Potion of Weaving",
  "item.minecraft.lingering_potion.effect.wind_charged": "Lingering Potion of Wind Charging",
  "item.minecraft.llama_spawn_egg": "Kreurovo di lamao",
  "item.minecraft.lodestone_compass": "Busolo magnetigita",
  "item.minecraft.mace": "Maco",
  "item.minecraft.magenta_bundle": "Magenta Bundle",
  "item.minecraft.magenta_dye": "Magenta tinto",
  "item.minecraft.magenta_harness": "Magenta Harness",
  "item.minecraft.magma_cream": "Kremo di magmo",
  "item.minecraft.magma_cube_spawn_egg": "Kreurovo di magmakubo",
  "item.minecraft.mangrove_boat": "Batelo mangliera",
  "item.minecraft.mangrove_chest_boat": "Batelo mangliera kun kofro",
  "item.minecraft.map": "Mapo vakua",
  "item.minecraft.melon_seeds": "Semini di melono",
  "item.minecraft.melon_slice": "Loncho di melono",
  "item.minecraft.milk_bucket": "Sitelo di lakto",
  "item.minecraft.minecart": "Minvagono",
  "item.minecraft.miner_pottery_shard": "Sherdo di argilo di mineanto",
  "item.minecraft.miner_pottery_sherd": "Sherdo di argilo di mineanto",
  "item.minecraft.mojang_banner_pattern": "Stendardo-Mustro",
  "item.minecraft.mojang_banner_pattern.desc": "Simbolo",
  "item.minecraft.mojang_banner_pattern.new": "Thing Banner Pattern",
  "item.minecraft.mooshroom_spawn_egg": "Kreurovo di mooshroomo",
  "item.minecraft.mourner_pottery_shard": "Sherdo di argilo di ploranto",
  "item.minecraft.mourner_pottery_sherd": "Sherdo di argilo di ploranto",
  "item.minecraft.mule_spawn_egg": "Kreurovo di mulo",
  "item.minecraft.mushroom_stew": "Fungoraguto",
  "item.minecraft.music_disc_11": "Muzikdisko",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Muzikdisko",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Muzikdisko",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Muzikdisko",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Muzikdisko",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Muzikdisko",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Music Disc",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Music Disc",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Music Box)",
  "item.minecraft.music_disc_far": "Muzikdisko",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Music Disc",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Muzikdisko",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Muzikdisko",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Muzikdisko",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Muzikdisko",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Music Disc",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Muzikala disko",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Muzikdisko",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Muzikdisko",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Music Disc",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Muzikdisko",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Muzikdisko",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Kruda mutonkarno",
  "item.minecraft.name_tag": "Nometiketo",
  "item.minecraft.nautilus_shell": "Konko di nautilo",
  "item.minecraft.nautilus_spawn_egg": "Nautilus Spawn Egg",
  "item.minecraft.nether_brick": "Netherbriko",
  "item.minecraft.nether_star": "Stelo di Nether",
  "item.minecraft.nether_wart": "Veruko di Nether",
  "item.minecraft.netherite_axe": "Hakilo netherita",
  "item.minecraft.netherite_boots": "Boti netherita",
  "item.minecraft.netherite_chestplate": "Torokuraso netherita",
  "item.minecraft.netherite_helmet": "Helmo netherita",
  "item.minecraft.netherite_hoe": "Bineto netherita",
  "item.minecraft.netherite_horse_armor": "Netherite Horse Armor",
  "item.minecraft.netherite_ingot": "Lingoto netherita",
  "item.minecraft.netherite_leggings": "Pantaloni netherita",
  "item.minecraft.netherite_nautilus_armor": "Netherite Nautilus Armor",
  "item.minecraft.netherite_pickaxe": "Piocho netherita",
  "item.minecraft.netherite_scrap": "Fragmento netherita",
  "item.minecraft.netherite_shovel": "Shovel netherita",
  "item.minecraft.netherite_spear": "Netherite Spear",
  "item.minecraft.netherite_sword": "Espado netherita",
  "item.minecraft.netherite_upgrade_smithing_template": "Forjo-Mustro",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netherite Upgrade",
  "item.minecraft.oak_boat": "Batelo querka",
  "item.minecraft.oak_chest_boat": "Batelo querka kun kofro",
  "item.minecraft.ocelot_spawn_egg": "Kreurovo di oceloto",
  "item.minecraft.ominous_bottle": "Ominous Bottle",
  "item.minecraft.ominous_trial_key": "Ominous Trial Key",
  "item.minecraft.orange_bundle": "Orange Bundle",
  "item.minecraft.orange_dye": "Oranjea tinto",
  "item.minecraft.orange_harness": "Orange Harness",
  "item.minecraft.painting": "Pikturo",
  "item.minecraft.pale_oak_boat": "Pale Oak Boat",
  "item.minecraft.pale_oak_chest_boat": "Pale Oak Boat with Chest",
  "item.minecraft.panda_spawn_egg": "Kreurovo di pando",
  "item.minecraft.paper": "Papero",
  "item.minecraft.parched_spawn_egg": "Parched Spawn Egg",
  "item.minecraft.parrot_spawn_egg": "Kreurovo di papagayo",
  "item.minecraft.phantom_membrane": "Membrano di fantomo",
  "item.minecraft.phantom_spawn_egg": "Kreurovo di fantomo",
  "item.minecraft.pig_spawn_egg": "Kreurovo di porko",
  "item.minecraft.piglin_banner_pattern": "Stendardo-Mustro",
  "item.minecraft.piglin_banner_pattern.desc": "Fasko",
  "item.minecraft.piglin_banner_pattern.new": "Snout Banner Pattern",
  "item.minecraft.piglin_brute_spawn_egg": "Kreurovo di piglinbruto",
  "item.minecraft.piglin_spawn_egg": "Kreurovo di piglino",
  "item.minecraft.pillager_spawn_egg": "Kreurovo di spoilanto",
  "item.minecraft.pink_bundle": "Pink Bundle",
  "item.minecraft.pink_dye": "Rozea tinto",
  "item.minecraft.pink_harness": "Pink Harness",
  "item.minecraft.pitcher_plant": "Pichilo-Planto",
  "item.minecraft.pitcher_pod": "Kruĉeto-Pod",
  "item.minecraft.plenty_pottery_shard": "Multe da Poterca Ŝarĝo",
  "item.minecraft.plenty_pottery_sherd": "Multe da Poterca Ŝardo",
  "item.minecraft.poisonous_potato": "Potato toxika",
  "item.minecraft.polar_bear_spawn_egg": "Kreurovo di urso blanka",
  "item.minecraft.popped_chorus_fruit": "Chorusfrukto krevita",
  "item.minecraft.porkchop": "Kruda porkokarno",
  "item.minecraft.potato": "Potato",
  "item.minecraft.potion": "Pociono",
  "item.minecraft.potion.effect.awkward": "Pociono stranja",
  "item.minecraft.potion.effect.empty": "Pociono nefabrikebla",
  "item.minecraft.potion.effect.fire_resistance": "Pociono di fairorezisto",
  "item.minecraft.potion.effect.harming": "Pociono di domajo",
  "item.minecraft.potion.effect.healing": "Pociono di remedio",
  "item.minecraft.potion.effect.infested": "Potion of Infestation",
  "item.minecraft.potion.effect.invisibility": "Pociono di nevidebleso",
  "item.minecraft.potion.effect.leaping": "Pociono di saltego",
  "item.minecraft.potion.effect.levitation": "Pociono di flugeteso",
  "item.minecraft.potion.effect.luck": "Pociono di chanco",
  "item.minecraft.potion.effect.mundane": "Pociono ordinara",
  "item.minecraft.potion.effect.night_vision": "Pociono di noktvidado",
  "item.minecraft.potion.effect.oozing": "Potion of Oozing",
  "item.minecraft.potion.effect.poison": "Pociono di toxiko",
  "item.minecraft.potion.effect.regeneration": "Pociono di regenereso",
  "item.minecraft.potion.effect.slow_falling": "Pociono di lenta faligo",
  "item.minecraft.potion.effect.slowness": "Pociono di lenteso",
  "item.minecraft.potion.effect.strength": "Pociono di forteso",
  "item.minecraft.potion.effect.swiftness": "Pociono di rapideso",
  "item.minecraft.potion.effect.thick": "Pociono densa",
  "item.minecraft.potion.effect.turtle_master": "Pociono di la tortugomastro",
  "item.minecraft.potion.effect.water": "Aquobotelo",
  "item.minecraft.potion.effect.water_breathing": "Pociono di aquarespiro",
  "item.minecraft.potion.effect.weakness": "Pociono di febleso",
  "item.minecraft.potion.effect.weaving": "Potion of Weaving",
  "item.minecraft.potion.effect.wind_charged": "Potion of Wind Charging",
  "item.minecraft.pottery_shard_archer": "Arĉisto de Poterca Ŝarĝo",
  "item.minecraft.pottery_shard_arms_up": "Poterca Ŝarĝo de Brakoj Supre",
  "item.minecraft.pottery_shard_prize": "Premia Poterca Ŝarĝo",
  "item.minecraft.pottery_shard_skull": "Kranio de Poterca Ŝarĝo",
  "item.minecraft.powder_snow_bucket": "Sitelo di nivo pulvera",
  "item.minecraft.prismarine_crystals": "Kristali di prismarino",
  "item.minecraft.prismarine_shard": "Ruptopeco di prismarino",
  "item.minecraft.prize_pottery_shard": "Premia Poterca Ŝarĝo",
  "item.minecraft.prize_pottery_sherd": "Premia Poterca Ŝardo",
  "item.minecraft.pufferfish": "Suflantofisho",
  "item.minecraft.pufferfish_bucket": "Sitelo di suflantofisho",
  "item.minecraft.pufferfish_spawn_egg": "Frayifanto-ovo di suflantofisho",
  "item.minecraft.pumpkin_pie": "Torto di kukurbito",
  "item.minecraft.pumpkin_seeds": "Semini di kukurbito",
  "item.minecraft.purple_bundle": "Purple Bundle",
  "item.minecraft.purple_dye": "Purpura tinto",
  "item.minecraft.purple_harness": "Purple Harness",
  "item.minecraft.quartz": "Quarco di Nether",
  "item.minecraft.rabbit": "Kruda kuniklokarno",
  "item.minecraft.rabbit_foot": "Pedo di kuniklo",
  "item.minecraft.rabbit_hide": "Felo di kuniklo",
  "item.minecraft.rabbit_spawn_egg": "Kreurovo di kuniklo",
  "item.minecraft.rabbit_stew": "Kunikloraguto",
  "item.minecraft.raiser_armor_trim_smithing_template": "Ŝablono por forĝado",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Raiser Armor Trim",
  "item.minecraft.ravager_spawn_egg": "Kreurovo di devastanto",
  "item.minecraft.raw_copper": "Kruda kupro",
  "item.minecraft.raw_gold": "Kruda oro",
  "item.minecraft.raw_iron": "Kruda fero",
  "item.minecraft.recovery_compass": "Busolo di rekupero",
  "item.minecraft.red_bundle": "Red Bundle",
  "item.minecraft.red_dye": "Reda tinto",
  "item.minecraft.red_harness": "Red Harness",
  "item.minecraft.redstone": "Pulvero di redstoneo",
  "item.minecraft.resin_brick": "Resin Brick",
  "item.minecraft.resin_clump": "Resin Clump",
  "item.minecraft.rib_armor_trim_smithing_template": "Ŝablono por forĝado",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Rib Armor Trim",
  "item.minecraft.rotten_flesh": "Karno putrinta",
  "item.minecraft.saddle": "Selo",
  "item.minecraft.salmon": "Kruda salmono",
  "item.minecraft.salmon_bucket": "Sitelo di salmono",
  "item.minecraft.salmon_spawn_egg": "Kreurovo di salmono",
  "item.minecraft.scrape_pottery_sherd": "Scrape Pottery Sherd",
  "item.minecraft.scute": "Skarpo",
  "item.minecraft.sentry_armor_trim_smithing_template": "Ŝablono por forĝado",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Sentry Armor Trim",
  "item.minecraft.shaper_armor_trim_smithing_template": "Ŝablono por forĝado",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Shaper Armor Trim",
  "item.minecraft.sheaf_pottery_shard": "Garbo de Poterca Ŝarĝo",
  "item.minecraft.sheaf_pottery_sherd": "Garbo de Poterca Ŝardo",
  "item.minecraft.shears": "Cizego",
  "item.minecraft.sheep_spawn_egg": "Kreurovo di mutono",
  "item.minecraft.shelter_pottery_shard": "Rifuĝejo de Poterca Ŝarĝo",
  "item.minecraft.shelter_pottery_sherd": "Rifuĝejo de Poterca Ŝardo",
  "item.minecraft.shield": "Shildo",
  "item.minecraft.shield.black": "Nigra shildo",
  "item.minecraft.shield.blue": "Blua shildo",
  "item.minecraft.shield.brown": "Bruna shildo",
  "item.minecraft.shield.cyan": "Cyana shildo",
  "item.minecraft.shield.gray": "Griza shildo",
  "item.minecraft.shield.green": "Verda shildo",
  "item.minecraft.shield.light_blue": "Cielblua shildo",
  "item.minecraft.shield.light_gray": "Klargriza shildo",
  "item.minecraft.shield.lime": "Klarverda shildo",
  "item.minecraft.shield.magenta": "Magenta shildo",
  "item.minecraft.shield.orange": "Oranjea shildo",
  "item.minecraft.shield.pink": "Rozea shildo",
  "item.minecraft.shield.purple": "Purpura shildo",
  "item.minecraft.shield.red": "Reda shildo",
  "item.minecraft.shield.white": "Blanka shildo",
  "item.minecraft.shield.yellow": "Flava shildo",
  "item.minecraft.shulker_shell": "Skalio di shulkero",
  "item.minecraft.shulker_spawn_egg": "Kreurovo di shulkero",
  "item.minecraft.sign": "Signo",
  "item.minecraft.silence_armor_trim_smithing_template": "Kovra Modelaĵo",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Silence Armor Trim",
  "item.minecraft.silverfish_spawn_egg": "Kreurovo di argentafisho",
  "item.minecraft.skeleton_horse_spawn_egg": "Kreurovo di skeleta kavalo",
  "item.minecraft.skeleton_spawn_egg": "Kreurovo di skeleto",
  "item.minecraft.skull_banner_pattern": "Standarda Ŝablono",
  "item.minecraft.skull_banner_pattern.desc": "Kranio",
  "item.minecraft.skull_banner_pattern.new": "Skull Charge Banner Pattern",
  "item.minecraft.skull_pottery_shard": "Krania Poterca Ŝarĝo",
  "item.minecraft.skull_pottery_sherd": "Krania Poterca Ŝardo",
  "item.minecraft.slime_ball": "Slambulo",
  "item.minecraft.slime_spawn_egg": "Kreurovo di slamo",
  "item.minecraft.smithing_template": "Kovra Modelaĵo",
  "item.minecraft.smithing_template.applies_to": "Aplikeblas al:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Aldoni metalaĵon aŭ kristalon",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Armilo",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Aldoni peco de armilo",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Slitoj kaj Kristaloj",
  "item.minecraft.smithing_template.ingredients": "Ingrediencoj:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Aldoni Inferplatan Sliton",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Diamanta Ekipaĵo",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Aldoni diamantan armilon, armilon, aŭ ilon",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Inferplata Slito",
  "item.minecraft.smithing_template.upgrade": "Altigo: ",
  "item.minecraft.sniffer_spawn_egg": "Esnifador Naskiĝa Ovo",
  "item.minecraft.snort_pottery_shard": "Frunza Poterca Ŝarĝo",
  "item.minecraft.snort_pottery_sherd": "Frunza Poterca Ŝardo",
  "item.minecraft.snout_armor_trim_smithing_template": "Kovra Modelaĵo",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Snout Armor Trim",
  "item.minecraft.snow_golem_spawn_egg": "Eko-Ovo de Neĝa Viro",
  "item.minecraft.snowball": "Nivbulo",
  "item.minecraft.spectral_arrow": "Flecho spektrala",
  "item.minecraft.spider_eye": "Okulo di araneo",
  "item.minecraft.spider_spawn_egg": "Kreurovo di araneo",
  "item.minecraft.spire_armor_trim_smithing_template": "Kovra Modelaĵo",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Spire Armor Trim",
  "item.minecraft.splash_potion": "Jetebla pociono",
  "item.minecraft.splash_potion.effect.awkward": "Jetebla pociono stranja",
  "item.minecraft.splash_potion.effect.empty": "Jetebla pociono nefabrikebla",
  "item.minecraft.splash_potion.effect.fire_resistance": "Jetebla pociono di fairorezisto",
  "item.minecraft.splash_potion.effect.harming": "Jetebla pociono di domajo",
  "item.minecraft.splash_potion.effect.healing": "Jetebla pociono di remedio",
  "item.minecraft.splash_potion.effect.infested": "Splash Potion of Infestation",
  "item.minecraft.splash_potion.effect.invisibility": "Jetebla pociono di nevidebleso",
  "item.minecraft.splash_potion.effect.leaping": "Jetebla pociono di saltego",
  "item.minecraft.splash_potion.effect.levitation": "Jetebla pociono di flugeteso",
  "item.minecraft.splash_potion.effect.luck": "Jetebla pociono di chanco",
  "item.minecraft.splash_potion.effect.mundane": "Jetebla pociono ordinara",
  "item.minecraft.splash_potion.effect.night_vision": "Jetebla pociono di noktvidado",
  "item.minecraft.splash_potion.effect.oozing": "Splash Potion of Oozing",
  "item.minecraft.splash_potion.effect.poison": "Jetebla pociono di toxiko",
  "item.minecraft.splash_potion.effect.regeneration": "Jetebla pociono di regenereso",
  "item.minecraft.splash_potion.effect.slow_falling": "Jetebla pociono di lenta faligo",
  "item.minecraft.splash_potion.effect.slowness": "Jetebla pociono di lenteso",
  "item.minecraft.splash_potion.effect.strength": "Jetebla pociono di forteso",
  "item.minecraft.splash_potion.effect.swiftness": "Jetebla pociono di rapideso",
  "item.minecraft.splash_potion.effect.thick": "Jetebla pociono densa",
  "item.minecraft.splash_potion.effect.turtle_master": "Jetebla pociono di tortugomastro",
  "item.minecraft.splash_potion.effect.water": "Jetebla aquobotelo",
  "item.minecraft.splash_potion.effect.water_breathing": "Jetebla pociono di aquarespiro",
  "item.minecraft.splash_potion.effect.weakness": "Jetebla pociono di febleso",
  "item.minecraft.splash_potion.effect.weaving": "Splash Potion of Weaving",
  "item.minecraft.splash_potion.effect.wind_charged": "Splash Potion of Wind Charging",
  "item.minecraft.spruce_boat": "Batelo abieta",
  "item.minecraft.spruce_chest_boat": "Batelo abieta kun kofro",
  "item.minecraft.spyglass": "Lorno",
  "item.minecraft.squid_spawn_egg": "Kreurovo di kalmaro",
  "item.minecraft.stick": "Bastono",
  "item.minecraft.stone_axe": "Hakilo petra",
  "item.minecraft.stone_hoe": "Bineto petra",
  "item.minecraft.stone_pickaxe": "Piocho petra",
  "item.minecraft.stone_shovel": "Shovelo petra",
  "item.minecraft.stone_spear": "Stone Spear",
  "item.minecraft.stone_sword": "Espado petra",
  "item.minecraft.stray_spawn_egg": "Kreurovo di vaganto",
  "item.minecraft.strider_spawn_egg": "Kreurovo di pazeganto",
  "item.minecraft.string": "Filo",
  "item.minecraft.sugar": "Sukro",
  "item.minecraft.suspicious_stew": "Stufajo suspektema",
  "item.minecraft.sweet_berries": "Dolcaberi",
  "item.minecraft.tadpole_bucket": "Sitelo di ranlarvo",
  "item.minecraft.tadpole_spawn_egg": "Kreurovo di ranlarvo",
  "item.minecraft.tide_armor_trim_smithing_template": "Kovra Modelaĵo",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Tide Armor Trim",
  "item.minecraft.tipped_arrow": "Flecho pintizita",
  "item.minecraft.tipped_arrow.effect.awkward": "Spica Frekanco",
  "item.minecraft.tipped_arrow.effect.empty": "Pintata flecho nefabrikebla",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Flecho di fairorezisto",
  "item.minecraft.tipped_arrow.effect.harming": "Flecho di domajo",
  "item.minecraft.tipped_arrow.effect.healing": "Flecho di remedio",
  "item.minecraft.tipped_arrow.effect.infested": "Arrow of Infestation",
  "item.minecraft.tipped_arrow.effect.invisibility": "Flecho di nevidebleso",
  "item.minecraft.tipped_arrow.effect.leaping": "Flecho di saltego",
  "item.minecraft.tipped_arrow.effect.levitation": "Flecho di flugeteso",
  "item.minecraft.tipped_arrow.effect.luck": "Flecho di chanco",
  "item.minecraft.tipped_arrow.effect.mundane": "Spica Frekanco",
  "item.minecraft.tipped_arrow.effect.night_vision": "Flecho di noktvidado",
  "item.minecraft.tipped_arrow.effect.oozing": "Arrow of Oozing",
  "item.minecraft.tipped_arrow.effect.poison": "Flecho di toxiko",
  "item.minecraft.tipped_arrow.effect.regeneration": "Flecho di regenereso",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Flecho di lenta faligo",
  "item.minecraft.tipped_arrow.effect.slowness": "Flecho di lenteso",
  "item.minecraft.tipped_arrow.effect.strength": "Flecho di forteso",
  "item.minecraft.tipped_arrow.effect.swiftness": "Flecho di rapideso",
  "item.minecraft.tipped_arrow.effect.thick": "Spica Frekanco",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Flecho di la tortugomastro",
  "item.minecraft.tipped_arrow.effect.water": "Flecho di plaudeso",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Flecho di aquarespiro",
  "item.minecraft.tipped_arrow.effect.weakness": "Flecho di febleso",
  "item.minecraft.tipped_arrow.effect.weaving": "Arrow of Weaving",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Arrow of Wind Charging",
  "item.minecraft.tnt_minecart": "Minvagono kun TNT",
  "item.minecraft.torchflower_seeds": "Semoj de Fajrofloro Semoj",
  "item.minecraft.totem_of_undying": "Totemo di nemortivado",
  "item.minecraft.trader_llama_spawn_egg": "Kreurovo di lamao komercanta",
  "item.minecraft.trial_key": "Provo-Klavo",
  "item.minecraft.trident": "Tridento",
  "item.minecraft.tropical_fish": "Fisho tropikala",
  "item.minecraft.tropical_fish_bucket": "Sitelo di fishi tropikala",
  "item.minecraft.tropical_fish_spawn_egg": "Kreurovo di fisho tropikala",
  "item.minecraft.turtle_helmet": "Skalio di torguto",
  "item.minecraft.turtle_scute": "Testudo Skarpo",
  "item.minecraft.turtle_spawn_egg": "Kreurovo di tortugo",
  "item.minecraft.vex_armor_trim_smithing_template": "Ŝablono por forĝado",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Vex Armor Trim",
  "item.minecraft.vex_spawn_egg": "Kreurovo di vexo",
  "item.minecraft.villager_spawn_egg": "Kreurovo di vilajano",
  "item.minecraft.vindicator_spawn_egg": "Kreurovo di vindikatoro",
  "item.minecraft.wandering_trader_spawn_egg": "Kreurovo vaganta komercanto",
  "item.minecraft.ward_armor_trim_smithing_template": "Ŝablono por forĝado",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Ward Armor Trim",
  "item.minecraft.warden_spawn_egg": "Ova por elirigo de Kustodanto",
  "item.minecraft.warped_fungus_on_a_stick": "Fungo bizara sur bastono",
  "item.minecraft.water_bucket": "Sitelo di Aquo",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Ŝablono por forĝado",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Wayfinder Armor Trim",
  "item.minecraft.wheat": "Frumento",
  "item.minecraft.wheat_seeds": "Semini di frumento",
  "item.minecraft.white_bundle": "White Bundle",
  "item.minecraft.white_dye": "Blanka tinto",
  "item.minecraft.white_harness": "White Harness",
  "item.minecraft.wild_armor_trim_smithing_template": "Ŝablono por forĝado",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Wild Armor Trim",
  "item.minecraft.wind_charge": "Vento ŝarĝo",
  "item.minecraft.witch_spawn_egg": "Kreurovo di sorcino",
  "item.minecraft.wither_skeleton_spawn_egg": "Kreurovo di witherskeleto",
  "item.minecraft.wither_spawn_egg": "Ova por elirigo de la Kontraŭulo",
  "item.minecraft.wolf_armor": "Lupo Armuro",
  "item.minecraft.wolf_spawn_egg": "Kreurovo di volfo",
  "item.minecraft.wooden_axe": "Hakilo ligna",
  "item.minecraft.wooden_hoe": "Bineto ligna",
  "item.minecraft.wooden_pickaxe": "Piocho ligna",
  "item.minecraft.wooden_shovel": "Shovelo ligna",
  "item.minecraft.wooden_spear": "Wooden Spear",
  "item.minecraft.wooden_sword": "Espado ligna",
  "item.minecraft.writable_book": "Libro e plumo",
  "item.minecraft.written_book": "Libro skribita",
  "item.minecraft.yellow_bundle": "Yellow Bundle",
  "item.minecraft.yellow_dye": "Flava tinto",
  "item.minecraft.yellow_harness": "Yellow Harness",
  "item.minecraft.zoglin_spawn_egg": "Kreurovo di zoglino",
  "item.minecraft.zombie_horse_spawn_egg": "Kreurovo di zombia kavalo",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombie Nautilus Spawn Egg",
  "item.minecraft.zombie_spawn_egg": "Kreurovo di zombio",
  "item.minecraft.zombie_villager_spawn_egg": "Kreurovo di zombia vilajano",
  "item.minecraft.zombified_piglin_spawn_egg": "Kreurovo di piglino zombigita"
}
export const io_en = items; 
